﻿import './NodeAssets.css'

export enum NodeIcon {
	SurveySVG = 1,
	SmsSVG = 2,
	PaperPlaneSVG = 3,
	Segment1SVG = 4,
	DollarSignSVG = 5,
	PhoneSVG = 6,
	UserSimpleSVG = 7,
	FacebookSVG = 8,
	GoogleSVG = 9,
	InstagramSVG = 10,
	FormSVG = 11,
	ClickSVG = 12,
	ClockSVG = 13,
	PauseSVG = 14,
	PlaySVG = 15,
	StopSVG = 16,
	ListSVG = 17,
	ConditionIfSVG = 18,
	CalendarSVG = 19,
	EmailSVG = 20,
	EmailBounceSVG = 21,
	EmailErrorSVG = 22,
	EmailOpenSVG = 23,
	EmailSendSVG = 24,
	VideoClipSVG = 25,
	DynamicDelay = 26,
	DynamicCondition = 27,
	TinyClockSVG = 28,
	PageGeneric = 29,
	PageImport = 30,
	PageOptIn = 31,
	PageSurvey = 32,
	EmailBounceFlatSVG = 33,
	EmailOpenFlatSVG = 34,
	UnsubFlatSVG = 35,
	ClickedFlatSVG = 36,
	BannedCursorSVG = 37,
	EmailFlatSVG = 38,
	EmailNotOpenedFlatSVG = 39,
	AnsweredSurveySVG = 40,
	NotAnsweredSurveySVG = 41,
}

export enum NodeFrame {
	None = 0,
	Polygon6 = 1,
	Circle = 2,
	Rombus = 3,
	RoundedSquare = 4,
	RoundedRect = 5,
	Polygon8 = 6
}

interface IconProps {
	transform?: string;
}
interface FrameProps {
	id: string;
}

/**
 * Rounded square frame
 * @returns Vector asset
 **/
export const RoundedSquare = () => <rect width="100" height="100" rx="7" />

/**
 * 6 sided polygon frame
 * @returns Vector asset
 **/
export const Polygon6 = () => (
	<path d="M5.6,28.9v42.1c0,2.8,1.5,5.4,3.9,6.8L46.1,99c2.4,1.4,5.4,1.4,7.9,0l36.5-21.1c2.4-1.4,3.9-4,3.9-6.8V28.9 c0-2.8-1.5-5.4-3.9-6.8L53.9,1c-2.4-1.4-5.4-1.4-7.9,0L9.6,22.1C7.1,23.5,5.6,26.1,5.6,28.9z" />
)

/**
 * 8 sided polygon frame
 * @returns Vector asset
 **/
export const Polygon8 = () => (
	<path d="M27.3,2L2,27.3c-1.3,1.3-2,3-2,4.7v35.9c0,1.8,0.7,3.5,2,4.7L27.3,98c1.3,1.3,3,2,4.7,2h35.9c1.8,0,3.5-0.7,4.7-2L98,72.7 c1.3-1.3,2-3,2-4.7V32.1c0-1.8-0.7-3.5-2-4.7L72.7,2c-1.3-1.3-3-2-4.7-2H32.1C30.3,0,28.6,0.7,27.3,2z" />
)

/**
 * Circle frame
 * @returns Vector asset
 **/
export const Circle = () => <circle cx="50" cy="50" r="50" />

/**
 * Rounded rectangle frame
 * @returns Vector asset
 **/
export const RoundedRect = () => <rect y="40" width="100" height="20" rx="3" />

/**
 * Rombus frame
 * @returns Vector asset
 **/
export const Rombus = () => (
	<path d="M98.4,53.9L53.9,98.4c-2.2,2.2-5.7,2.2-7.8,0L1.6,53.9c-2.2-2.2-2.2-5.7,0-7.8L46.1,1.6c2.2-2.2,5.7-2.2,7.8,0l44.5,44.5 C100.5,48.2,100.5,51.8,98.4,53.9z" />
)

/**
 *'''''''''''''''''''
 *       newline regex ->>>>           (?<="|\w|\d)[\n]\s+
 *  */

/**
 * Survey icon
 * @returns Vector asset
 **/
export const SurveySVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon" d="M67.6,35.1v22.5H31.3V35.1H67.6z" />
		<path
			class="node-fill-inverted-frame"
			d="M66.9,34H32c-0.7,0-1.5,0.6-1.5,1.5v21.8c0,0.7,0.6,1.5,1.5,1.4h7.8l1.2,0.8h2.2l-4.9,10.7 c-0.2,0.5,0.2,0.9,0.6,0.9h0.4c0,0,0.4-0.2,0.6-0.4l3.4-7.3H49v4.4c0,0.4,0.3,0.6,0.6,0.6c0.3,0,0.6-0.1,0.9-0.6v-4.4h5.4l3.4,7.3 C59.5,70.8,60,71,60,71h0.4c0.5,0,0.8-0.5,0.6-0.9l-4.8-10.7h2.1l1.2-0.8H67c0.7,0,1.3-0.5,1.3-1.4V35.5 C68.2,34.7,67.7,34,66.9,34z M43.2,62.5l1.5-3.1H49v3.1H43.2z M56.4,62.5h-5.8v-3.1h4.4L56.4,62.5z M32,57.4 c-0.3,0-0.4-0.1-0.4-0.4V35.5c0-0.2,0.2-0.4,0.4-0.4h34.8c0.2,0,0.4,0.2,0.4,0.4v21.6c0,0.2-0.2,0.4-0.4,0.4L32,57.4z"
		/>
		<g class="node-fill-icon-secondary">
			<path d="M43.6,49.4h-0.6c-1,0-1.6-0.7-1.6-1.4v-1.8c0-0.8,0.8-1.4,1.6-1.4h0.6c1,0,1.6,0.7,1.6,1.4V48 C45.2,48.9,44.4,49.4,43.6,49.4z" />
			<path d="M50,49.4h-0.9c-0.8,0-1.5-0.6-1.5-1.5l0,0c0-0.8,0.6-1.5,1.5-1.5H50c0.8,0,1.5,0.6,1.5,1.5l0,0 C51.5,48.8,50.8,49.4,50,49.4z" />
			<path d="M56.7,49.4H56c-1,0-1.6-0.8-1.6-1.5v-5.5c0-0.9,0.8-1.5,1.6-1.5h0.6c1,0,1.6,0.8,1.6,1.5v5.5 C58.3,48.8,57.5,49.4,56.7,49.4z" />
		</g>
		<g class="node-fill-inverted-primary">
			<path d="M42.8,51.7h0.3l0.9,2.3h-0.4l-0.1-0.8h-0.7l-0.1,0.8h-0.4L42.8,51.7z" />

			<path d="M49.7,51.7c0,0,0.7,0.1,0.7,0.3c0,0.4-0.3,0.6-0.3,0.6c0.1,0,0.5,0.3,0.5,0.4c0.1,0.2,0,0.4-0.2,0.6 c-0.3,0.3-0.5,0.3-0.7,0.3c-0.2,0-0.7,0-0.7,0v-2.3H49.7z" />

			<path d="M56.7,51.8v0.4c-0.1-0.1-0.4-0.1-0.6-0.1c-0.1,0-0.3,0-0.4,0.1s-0.1,0.3-0.1,0.4c0,0.1,0,0.3,0.1,0.4 s0.3,0.1,0.4,0.1c0.1,0,0.3,0,0.6-0.1v0.4c-0.3,0.1-0.4,0.1-0.6,0.1c-0.3,0-0.6-0.2-0.7-0.3s-0.3-0.4-0.3-0.7s0.1-0.6,0.3-0.7 s0.4-0.3,0.7-0.3C56.3,51.6,56.4,51.6,56.7,51.8z" />
		</g>
	</g>
)

/**
 * Paper plane icon
 * @returns Vector asset
 **/
export const PaperPlaneSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon-shadow" d="M100,65.9L70.8,34.3L25.4,54.8L72,100h28V65.9z" />
		<g class="node-icon">
			<polygon style="filter: brightness(.6)" points="44.4,59.2 44.4,67.8 51.2,63.1 		" />
			<polygon style="filter: brightness(.8)" points="44.4,67.8 39.4,57.8 70.9,34 44.4,59.2 		" />
			<polygon points="59.5,67.8 44.4,59.2 70.9,34 		" />
			<polygon points="39.4,57.8 25.1,54.9 70.9,34 		" />
		</g>
		<g class="node-fill-inverted-primary" opacity=".1">
			<polygon points="59.5,67.8 58.3,67.2 70.9,34 		" />
			<polygon points="59.5,36.3 32.8,38.6 37.1,36 62.3,35.3 	" />
			<polygon points="49.4,41.2 23.4,45.2 21.2,43.3 47,40.6 	" />
		</g>
	</g>
)

/**
 * Four squares segment icon
 * @returns Vector asset
 **/
export const Segment1SVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon-shadow" d="M100,66.8L70.6,31.1L52,31.6l-3.6-2.4l-18.9,0.9l-0.4,18.4l3.3,4.2l-1.6,17.5L63.9,100H100V66.8z" />
		<g class="node-fill-icon-secondary">
			<path
				style="filter: saturate(4)"
				d="M30.6,51.3v18.4c0,0.4,0.4,1,1,1h18.6V51.3H30.6z M40.7,55.8c1,0,1.9,0.9,1.9,1.9c0,1-0.9,1.9-1.9,1.9 c-1,0-1.9-0.9-1.9-1.9C38.8,56.5,39.7,55.8,40.7,55.8z M44.1,65.2h-7l-0.3-0.9c0-2.1,1.6-3.7,3.7-3.7c2.1,0,3.7,1.6,3.7,3.7 L44.1,65.2z"
			/>

			<path
				style="filter: saturate(4) hue-rotate(120deg)"
				d="M51.3,51.3v19.3h18.6c0.4,0,0.9-0.4,0.9-1V51.3H51.3z M60.8,55.8c1,0,1.9,0.9,1.9,1.9c0,1-0.9,1.9-1.9,1.9 c-1,0-1.9-0.9-1.9-1.9C58.8,56.7,59.7,55.8,60.8,55.8z M64.3,65.3h-7l-0.1-1c0-2.1,1.6-3.7,3.7-3.7c2.1,0,3.7,1.6,3.7,3.7 L64.3,65.3z"
			/>

			<path
				style="filter: saturate(4) hue-rotate(240deg)"
				d="M51.3,50.1h19.6V31.7c0-0.4-0.4-0.9-0.9-0.9H51.3L51.3,50.1L51.3,50.1z M60.8,36c1,0,1.9,0.9,1.9,1.9 c0,1-0.9,1.9-1.9,1.9c-1,0-1.9-0.9-1.9-1.9S59.7,36,60.8,36z M57.1,44.3c0-2.1,1.6-3.7,3.7-3.7c2.1,0,3.7,1.6,3.7,3.7l-0.1,0.9 h-7L57.1,44.3z"
			/>
		</g>
		<g class="node-icon">
			<path d="M39.7,32.3c0,0.3-0.3,0.6-0.6,0.6c-0.3,0-0.6-0.3-0.6-0.6v-1H31v7.3h1.3c0.3,0,0.6,0.3,0.6,0.6 s-0.3,0.6-0.6,0.6h-1.2V47h7.4v-1c0-0.3,0.3-0.6,0.6-0.6c0.3,0,0.6,0.3,0.6,0.6v1h7.4v-7.3h-1c-0.3,0-0.6-0.3-0.6-0.6 s0.3-0.6,0.6-0.6h1v-7.3h-7.4L39.7,32.3L39.7,32.3z M42.6,42.4l-0.3,1h-6.4l-0.3-1c0-1.9,1.5-3.4,3.4-3.4 C41,39,42.6,40.5,42.6,42.4z M40.9,36.5c0,1-0.7,1.8-1.8,1.8s-1.8-0.7-1.8-1.8s0.7-1.8,1.8-1.8S40.9,35.4,40.9,36.5z" />
			<path d="M49.2,48.2V30.1c0-0.4-0.4-0.9-0.9-0.9H30c-0.4,0-0.9,0.4-0.9,0.9v18.1c0,0.4,0.4,0.9,0.9,0.9h18.3 C48.7,49.1,49.2,48.8,49.2,48.2z M48.1,47.2c0,0.4-0.4,0.9-0.9,0.9H31c-0.4,0-0.9-0.4-0.9-0.9V31.1c0-0.4,0.4-0.9,0.9-0.9h16.1 c0.4,0,0.9,0.4,0.9,0.9L48.1,47.2L48.1,47.2z" />
		</g>
	</g>
)

/**
 * Dollar sign icon
 * @returns Vector asset
 **/
export const DollarSignSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="52.4,27.4 100,72.5 100,100 73.2,100 38.3,62.7 43,56 52.4,64.7 54.9,62.9 40.2,49.6 43.3,40.9 	" />

		<path
			class="node-icon"
			d="M52.2,67.4v5.2h-4.5v-5.2c-6.7-0.7-10.7-4-12.3-9.7l7.6-1.7c0.9,3.3,3.3,5,7.2,5c1.9,0,3.3-0.3,4.3-1 c0.9-0.7,1.4-1.6,1.4-2.6s-0.3-1.9-1.2-2.4c-0.9-0.5-2.4-1-4.8-1.6c-5.3-1-8.6-2.6-10.2-4.3c-1.6-1.9-2.2-4-2.2-6.4 c0-2.9,1-5.3,2.9-7.4c1.9-2.1,4.5-3.3,7.4-3.6v-4.3h4.5v4.3c5.7,0.5,9.5,3.3,11.2,8.3l-7.1,2.4c-0.9-2.8-2.9-4.1-6-4.1 c-3.3,0-4.8,1-4.8,3.1c0,0.9,0.3,1.6,0.9,2.1c0.7,0.5,2.1,1,4.1,1.6c3.6,0.7,6.2,1.4,7.9,2.2c1.7,0.7,3.1,1.9,4.1,3.6 c1.2,1.7,1.7,3.5,1.7,5.5c0,2.8-1,5.3-3.1,7.6C59.3,65.7,56.4,67.1,52.2,67.4z"
		/>
	</g>
)

/**
 * Calendar icon
 * @returns Vector asset
 **/
export const CalendarSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon" d="M31.4,40.8v22.8c0,2.2,1.7,3.9,3.8,3.9h29.7c2,0,3.8-1.7,3.8-3.9V40.8H31.4z" />
		<path class="node-fill-icon-secondary" style="filter: saturate(3)" d="M31.4,40.2v-4.1c0-2.2,1.7-3.9,3.8-3.9h29.7c2,0,3.8,1.7,3.8,3.9v4.1H31.4z" />
		<g class="node-fill-icon-secondary" style="filter: saturate(7) hue-rotate(140deg)">
			<path d="M43.2,44.4l0.8,2.6h2.8c0.4,0,0.6,0.5,0.2,0.8l-2.2,1.5l0.9,2.7c0.1,0.4-0.3,0.7-0.6,0.5L42.8,51l-2.3,1.6 c-0.3,0.2-0.8-0.1-0.7-0.5l0.8-2.7l-2.1-1.5c-0.3-0.2-0.2-0.8,0.3-0.8h2.7l0.9-2.6C42.5,44,43.1,44,43.2,44.4z" />
			<path d="M40,60.1h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9H40c0.5,0,0.9,0.4,0.9,0.9v2.7 C40.9,59.7,40.5,60.1,40,60.1z" />
			<path d="M47.3,60.1h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v2.7 C48.2,59.7,47.8,60.1,47.3,60.1z" />
			<path d="M54.5,60.1h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v2.7 C55.4,59.7,55,60.1,54.5,60.1z" />
			<path d="M61.6,60.1H59c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v2.7 C62.5,59.7,62.1,60.1,61.6,60.1z" />
			<path d="M61.6,53.3H59c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v2.7 C62.5,52.9,62.1,53.3,61.6,53.3z" />
			<path d="M54.5,53.3h-2.7c-0.5,0-0.9-0.4-0.9-0.9v-2.7c0-0.5,0.4-0.9,0.9-0.9h2.7c0.5,0,0.9,0.4,0.9,0.9v2.7 C55.4,52.9,55,53.3,54.5,53.3z" />
		</g>
		<g class="node-fill-inverted-frame">
			<path d="M39.6,35.3L39.6,35.3c-0.9,0-1.6-0.7-1.6-1.6v-3.6c0-0.9,0.7-1.6,1.6-1.6l0,0c0.9,0,1.6,0.7,1.6,1.6v3.6 C41.4,34.6,40.6,35.3,39.6,35.3z" />
			<path d="M60.7,35.3L60.7,35.3c-0.9,0-1.6-0.7-1.6-1.6v-3.6c0-0.9,0.7-1.6,1.6-1.6l0,0c0.9,0,1.6,0.7,1.6,1.6v3.6 C62.3,34.6,61.5,35.3,60.7,35.3z" />
		</g>
	</g>
)

/**
 * Phone icon
 * @returns Vector asset
 **/
export const PhoneSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon-shadow" d="M100,57L71.8,28.3L60,58.9L28.1,71.1L57.9,100H100V57z" />
		<g class="node-icon">
			<path
				style="filter: brightness(1.1)"
				d="M67.5,27.5h-5.9c-1.3,0-2.5,1.2-2.5,2.5c0,3.2-0.5,6.2-1.5,8.9c-0.3,0.8,0,1.8,0.7,2.5l5.4,5.4 c0.6-1.1,2.6-5.3,3.2-8.9C67.5,33.7,67.5,27.5,67.5,27.5z"
			/>
			<path
				style="filter: brightness(1.1)"
				d="M38.5,67c5.7-1.3,8.5-3.3,8.5-3.3l-5.5-5.5c-0.7-0.7-1.7-0.8-2.5-0.7c-2.8,1-5.9,1.5-8.9,1.5 c-1.3,0-2.5,1.2-2.5,2.5v6.7c0.1,0,0.4,0,0.7,0C29.9,68.2,34,68.1,38.5,67z"
			/>
			<path d="M70.1,27.5h-2.6h-0.1c0,0,0,6.2-0.7,10.4c-0.6,3.6-2.7,7.8-3.2,8.9c-0.1,0.2-0.1,0.3-0.1,0.3 C59.9,54.1,54,60,47,63.5c0,0-2.8,2-8.5,3.3c-4.4,1-8.5,1.2-10.1,1.2c-0.5,0-0.7,0-0.7,0v2c0,1.3,1.2,2.5,2.5,2.5 c23.4,0,42.5-19.1,42.5-42.5C72.6,28.7,71.4,27.5,70.1,27.5z" />
		</g>
	</g>
)

/**
 * Simple user icon icon
 * @returns Vector asset
 **/
export const UserSimpleSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="31.9,64.5 68.5,100 100,100 100,75.7 55.8,31.3 45.2,46.1 52.8,53.3 " />
		<path
			class="node-icon"
			d="M70,60.2c0,6-8.8,10.8-20,10.8s-20-4.8-20-10.8s8.8-10.8,20-10.8S70,54.2,70,60.2z M50,47.3 c5,0,9.2-4.2,9.2-9.2S55,29,50,29s-9.2,4.2-9.2,9.2S45,47.3,50,47.3z"
		/>
	</g>
)

/**
 * Facebook icon
 * @returns Vector asset
 **/
export const FacebookSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="45,71 74.4,100 100,100 100,71.8 60.8,29.4 39,52 45,57.5 " />
		<path class="node-icon" d="M55,29c-5.5,0-10,4.5-10,10v5h-6v8h6v19h8V52h7l1-8h-8v-4c0-2.2,1.8-4,4-4h4v-6.7C59.1,29.1,56.9,29,55,29 L55,29z" />
	</g>
)

/**
 * Google icon
 * @returns Vector asset
 **/
export const GoogleSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="32.5,62.3 71.5,100 100,100 100,68 64.5,32.8 37.5,36.7 " />
		<g class="node-icon">
			<path d="M71.5,49.9c0-1.5-0.2-3.1-0.3-4.5H50.4v8.5h11.9c-0.5,2.7-2.1,5.2-4.4,6.6V66h7.1 C69.1,62.3,71.5,56.7,71.5,49.9L71.5,49.9z" />
		</g>
		<g class="node-fill-icon-secondary">
			<path
				style="filter: saturate(4)"
				d="M50.4,71.3c6,0,11.1-1.9,14.7-5.3L58,60.5c-1.9,1.3-4.7,2.1-7.6,2.1c-5.8,0-10.6-3.9-12.4-9h-7.3l0,5.8 C34.5,66.8,42,71.3,50.4,71.3z"
			/>
			<path style="filter: saturate(4) hue-rotate(120deg)" d="M38,53.6c-1-2.7-1-5.6,0-8.4v-5.6h-7.3c-3.1,6.3-3.1,13.5,0,19.8L38,53.6z" />
			<path
				style="filter: saturate(4) hue-rotate(240deg)"
				d="M50.4,36.2c3.1,0,6.1,1.1,8.4,3.2l6.3-6.3c-4-3.7-9.2-5.8-14.7-5.8c-8.4,0-16,4.8-19.7,12.2l7.3,5.6 C39.8,40.2,44.6,36.2,50.4,36.2z"
			/>
		</g>
	</g>
)

/**
 * Instagram icon
 * @returns Vector asset
 **/
export const InstagramSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="30.6,68.8 62.5,100 100,100 100,62 69,30.8 " />
		<path
			class="node-icon"
			d="M62.2,72l-24.4,0c-5.4,0-9.8-4.4-9.8-9.8l0-24.4c0-5.4,4.4-9.8,9.8-9.8l24.4,0c5.4,0,9.8,4.4,9.8,9.8l0,24.4 C72,67.6,67.6,72,62.2,72z"
		/>
		<g class="node-fill-icon-secondary">
			<path d="M50,58.6c-4.7,0-8.6-3.8-8.6-8.6s3.8-8.6,8.6-8.6s8.6,3.8,8.6,8.6S54.7,58.6,50,58.6z M50,43.9 c-3.4,0-6.1,2.7-6.1,6.1s2.7,6.1,6.1,6.1s6.1-2.7,6.1-6.1S53.4,43.9,50,43.9z" />
			<circle cx="50" cy="50" r="1.8" />
			<path d="M57.3,65.9H42.7c-4.7,0-8.6-3.8-8.6-8.6V42.7c0-4.7,3.8-8.6,8.6-8.6h14.7c4.7,0,8.6,3.8,8.6,8.6v14.7 C65.9,62,62,65.9,57.3,65.9z M42.7,36.6c-3.4,0-6.1,2.7-6.1,6.1v14.7c0,3.4,2.7,6.1,6.1,6.1h14.7c3.4,0,6.1-2.7,6.1-6.1V42.7 c0-3.4-2.7-6.1-6.1-6.1H42.7z" />
		</g>
	</g>
)

/**
 * Click icon
 * @returns Vector asset
 **/
export const ClickSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon-shadow" d="M100,67L72.7,33.1L26.8,61.5l34,38.5H100V67z" />
		<path
			class="node-icon"
			d="M68.1,31.3H31.9c-3.8,0-6.9,3.1-6.9,6.9v18.5c0,3.8,3.1,6.9,6.9,6.9h36.1c3.8,0,6.9-3.1,6.9-6.9V38.3 C75,34.4,71.9,31.3,68.1,31.3z"
		/>

		<path class="node-icon-shadow" d="M33.5,31.3h-1.5c-3.8,0-6.9,3.1-6.9,6.9v18.5c0,3.8,3.1,6.9,6.9,6.9h4.4C33.8,58.7,29.2,46.5,33.5,31.3z" />

		<g class="node-fill-icon-secondary">
			<path d="M63.6,67.7L58.9,74c-1.6,1.4-4.1,0.5-4.3-1.6l-2-21.9c-0.2-1.8,1.9-2.9,3.2-1.8l17.6,13.1c1.7,1.3,1.1,4-1,4.5 l-6.7,0.3C64.9,66.6,64.1,67,63.6,67.7z" />
			<path d="M54.1,43h-0.5c-0.5,0-0.9-0.4-0.9-0.9v-7.4c0-0.5,0.4-0.9,0.9-0.9h0.5c0.5,0,0.9,0.4,0.9,0.9v7.4 C55,42.6,54.6,43,54.1,43z" />
			<path d="M38.5,49.4l0-0.5c0-0.5,0.4-0.9,0.9-0.9h7.4c0.5,0,0.9,0.4,0.9,0.9v0.5c0,0.5-0.4,0.9-0.9,0.9h-7.4 C38.9,50.3,38.5,49.9,38.5,49.4z" />
			<path d="M58.3,45L58,44.7c-0.3-0.3-0.3-0.9,0-1.3l5.2-5.2c0.3-0.3,0.9-0.3,1.3,0l0.3,0.3c0.3,0.3,0.3,0.9,0,1.3 L59.6,45C59.3,45.3,58.7,45.3,58.3,45z" />
			<path d="M42.8,38.5l0.3-0.3c0.3-0.3,0.9-0.3,1.3,0l5.2,5.2c0.3,0.3,0.3,0.9,0,1.3l-0.3,0.3c-0.3,0.3-0.9,0.3-1.3,0 l-5.2-5.2C42.5,39.5,42.5,38.9,42.8,38.5z" />
			<path d="M43.2,60.2l-0.3-0.3c-0.3-0.3-0.3-0.9,0-1.3l5.2-5.2c0.3-0.3,0.9-0.3,1.3,0l0.3,0.3c0.3,0.3,0.3,0.9,0,1.3 l-5.2,5.2C44.1,60.5,43.5,60.5,43.2,60.2z" />
		</g>
	</g>
)

/**
 * Clock icon
 * @returns Vector asset
 **/
export const ClockSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="68.5,100 100,100 100,68.2 64.4,33.1 33.3,64.2 " />
		<path class="node-icon" d="M28,50c0-12.1,9.9-22,22-22s22,9.9,22,22s-9.9,22-22,22S28,62.1,28,50z" />
		<path
			class="node-fill-inverted-primary"
			d="M31.2,50c0-10.4,8.4-18.8,18.8-18.8c10.4,0,18.8,8.4,18.8,18.8c0,10.4-8.4,18.8-18.8,18.8 C39.6,68.8,31.2,60.4,31.2,50z"
		/>
		<path class="node-icon" d="M33.3,50c0-9.2,7.5-16.7,16.7-16.7c9.2,0,16.7,7.5,16.7,16.7S59.2,66.7,50,66.7C40.8,66.7,33.3,59.2,33.3,50z" />
		<g class="node-fill-inverted-primary">
			<path d="M50,52.6c-1.4,0-2.6-1.2-2.6-2.6s1.2-2.6,2.6-2.6s2.6,1.2,2.6,2.6S51.4,52.6,50,52.6z" />
			<path d="M50,50.8h-9.6c-0.5,0-0.8-0.4-0.8-0.8s0.4-0.8,0.8-0.8H50c0.5,0,0.8,0.4,0.8,0.8S50.5,50.8,50,50.8z" />
			<path d="M50,50.8c-0.2,0-0.4-0.1-0.6-0.3c-0.3-0.3-0.3-0.9,0-1.2l6.8-6.8c0.3-0.3,0.9-0.3,1.2,0c0.3,0.3,0.3,0.9,0,1.2 l-6.8,6.8C50.4,50.8,50.2,50.8,50,50.8z" />
			<path d="M50,35c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C51.1,35.4,50.6,35,50,35z M50,62.9c-0.6,0-1.1,0.5-1.1,1.1S49.4,65,50,65c0.6,0,1.1-0.5,1.1-1.1S50.6,62.9,50,62.9z" />
			<path d="M64,48.9c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1S65,50.6,65,50C65,49.4,64.6,48.9,64,48.9z M36,48.9 c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C37.1,49.4,36.7,48.9,36,48.9z" />
			<path d="M59.9,39c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1C61,39.5,60.5,39,59.9,39z M40.1,58.8 c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1S40.7,58.8,40.1,58.8z" />
			<path d="M59.9,58.8c-0.6,0-1.1,0.5-1.1,1.1s0.5,1.1,1.1,1.1s1.1-0.5,1.1-1.1S60.5,58.8,59.9,58.8z M40.1,39 c-0.6,0-1.1,0.5-1.1,1.1c0,0.6,0.5,1.1,1.1,1.1c0.6,0,1.1-0.5,1.1-1.1C41.2,39.5,40.7,39,40.1,39z" />
		</g>
	</g>
)

/**
 * Pause icon
 * @returns Vector asset
 **/
export const PauseSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="65.1,100 100,100 100,64.9 64.3,28.5 64.3,51.5 43,28.3 35.6,71.3 " />
		<g class="node-icon">
			<path d="M62.8,72h-4.8c-1.1,0-2.1-0.9-2.1-2.1V30.1c0-1.1,0.9-2.1,2.1-2.1h4.8c1.1,0,2.1,0.9,2.1,2.1v39.8 C64.9,71.1,64,72,62.8,72z" />
			<path d="M41.9,72h-4.8c-1.1,0-2.1-0.9-2.1-2.1V30.1c0-1.1,0.9-2.1,2.1-2.1h4.8c1.1,0,2.1,0.9,2.1,2.1v39.8 C44,71.1,43.1,72,41.9,72z" />
		</g>
		<g class="node-icon-shadow" opacity=".3">
			<path d="M62.8,72h-4.8c-1.1,0-2.1-0.9-2.1-2.1V50.1c3,0.6,5.9,0.6,8.9,0v19.8C64.9,71.1,64,72,62.8,72z" />
			<path d="M41.9,72h-4.8c-1.1,0-2.1-0.9-2.1-2.1V50.1c3,0.6,5.9,0.6,8.9,0v19.8C44,71.1,43.1,72,41.9,72z" />
		</g>
	</g>
)

/**
 * Play icon
 * @returns Vector asset
 **/
export const PlaySVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="65.4,100 100,100 100,80.7 70.6,47.8 35.9,71.3 " />

		<path class="node-icon" d="M34.6,68.6V31.4c0-2.7,2.9-4.3,5.2-2.9l29.9,18.6c2.1,1.3,2.1,4.5,0,5.8L39.9,71.5 C37.6,72.9,34.6,71.3,34.6,68.6z" />

		<path
			class="node-icon-shadow"
			opacity=".3"
			d="M34.6,68.6V51.2c7.5,0.6,28.4,0.8,36.7-1.2c0,1.1-0.5,2.2-1.6,2.9L39.9,71.5C37.6,72.9,34.6,71.3,34.6,68.6z"
		/>
	</g>
)

/**
 * Stop icon
 * @returns Vector asset
 **/
export const StopSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="65,100 100,100 100,59.9 68.4,31.6 31.2,68.4 " />
		<path
			class="node-icon"
			d="M65.8,69.5H34.2c-2.1,0-3.7-1.7-3.7-3.7V34.2c0-2.1,1.7-3.7,3.7-3.7h31.6c2.1,0,3.7,1.7,3.7,3.7v31.6 C69.5,67.8,67.8,69.5,65.8,69.5z"
		/>
		<path class="node-icon-shadow" opacity=".3" d="M66.2,69.5H33.8c-1.8,0-3.3-1.5-3.3-3.3l0-16.2c13,0.7,26,0.7,39,0l0,16.2C69.5,66.2,68,69.5,66.2,69.5z" />
	</g>
)

/**
 * Email icon
 * @returns Vector asset
 **/
export const EmailSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<g class="node-icon">
			<path
				style="filter: brightness(.85)"
				d="M72,39.7v20.6c0,2.5-2,4.4-4.4,4.4H32.4c-2.5,0-4.4-2-4.4-4.4V39.7c0-0.5,0-1.1,0.3-1.6l0.2-0.3 c0,0,2.2-2.5,3.7-2.5h35.3c1.7,0,3.3,0.9,3.9,2.5c0,0,0,0,0,0.2c0,0,0,0,0,0.2C72,38.6,72,39.2,72,39.7z"
			/>

			<path d="M71.1,39.9L50.8,51.2c-0.2,0.2-0.5,0.2-0.8,0.2s-0.5,0-0.8-0.2L28.9,39.9c-0.6-0.3-0.9-1.2-0.6-1.9 c0.8-1.7,2.3-2.7,4.1-2.7h35.3c1.7,0,3.4,1.1,4.1,2.7C72,38.8,71.7,39.5,71.1,39.9z" />
		</g>
	</g>
)

/**
 * Email error icon
 * @returns Vector asset
 **/
export const EmailErrorSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="71.6,37.6 29.3,63 66.3,100 100,100 100,66 	" />
		<g class="node-icon">
			<path
				style="filter: brightness(.85)"
				d="M72,39.7v20.6c0,2.5-2,4.4-4.4,4.4H32.4c-2.5,0-4.4-2-4.4-4.4V39.7c0-0.5,0.3-1.6,0.3-1.6L71.7,38 C72,38.7,72,39.2,72,39.7z"
			/>
			<path d="M71.1,39.9L50.8,51.2c-0.2,0.2-0.5,0.2-0.8,0.2s-0.5,0-0.8-0.2L28.9,39.9c-0.6-0.3-0.9-1.2-0.6-1.9 c0.8-1.7,2.3-2.7,4.1-2.7h35.3c1.7,0,3.4,1.1,4.1,2.7C72,38.8,71.7,39.5,71.1,39.9z" />
		</g>
		<path class="node-icon-shadow" opacity=".5" d="M69.8,64L53.7,47.3l-12,9.2l8,8.1h16.9C67.8,64.7,68.9,64.7,69.8,64z" />
		<path fill="red" d="M58.4,54.8c0.6,1.1-0.2,2.3-1.4,2.3H43c-1.2,0-2-1.4-1.4-2.3l7-11.4c0.6-0.9,2-0.9,2.7,0 L58.4,54.8z" />
		<g fill="#fff">
			<path d="M50.8,53.9c0.2,0.2,0.3,0.5,0.3,0.8s-0.2,0.6-0.3,0.8c-0.2,0.2-0.5,0.3-0.8,0.3 c-0.6,0-1.1-0.5-1.1-1.1c0-0.3,0.2-0.6,0.3-0.8c0.2-0.2,0.5-0.3,0.8-0.3S50.6,53.7,50.8,53.9z" />
			<path d="M51.1,46.9v4.4c0,0.6-0.5,1.1-1.1,1.1s-1.1-0.5-1.1-1.1v-4.4c0-0.6,0.5-1.1,1.1-1.1 c0.3,0,0.6,0.2,0.8,0.3S51.1,46.6,51.1,46.9z" />
		</g>
	</g>
)

/**
 * Video clip icon
 * @returns Vector asset
 **/
export const VideoClipSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="71.4,33.7 29.2,34.1 28.5,64.1 65.7,100 100,100 100,62.1 	" />
		<rect class="node-fill-inverted-primary" x="35.4" y="35.7" width="28.9" height="25.9" />
		<path class="node-fill-icon-secondary" d="M54.8,49.6l-9,4.7c-0.5,0.2-1-0.1-1-0.6v-9.5c0-0.5,0.5-0.8,1-0.6l9,4.7C55.3,48.6,55.3,49.4,54.8,49.6z" />
		<path
			class="node-icon"
			d="M69.9,33.1H30.1c-1.2,0-2.1,1-2.1,2.1v27.5c0,1.2,1,2.1,2.1,2.1h39.7c1.2,0,2.1-1,2.1-2.1V35.3C72,34.1,71,33.1,69.9,33.1z M34.2,62.8h-3.7v-3.4h3.7V62.8z M34.2,56.8h-3.7v-3.4h3.7V56.8z M34.2,50.7h-3.7v-3.4h3.7V50.7z M34.2,44.7h-3.7v-3.4h3.7V44.7z M34.2,38.6h-3.7v-3.4h3.7V38.6z M62.9,57.9c0,1.2-1,2.1-2.1,2.1H39.2c-1.2,0-2.1-1-2.1-2.1V40.1c0-1.2,1-2.1,2.1-2.1h21.6 c1.2,0,2.1,1,2.1,2.1V57.9z M69.5,62.8h-3.7v-3.4h3.7V62.8z M69.5,56.8h-3.7v-3.4h3.7V56.8z M69.5,50.7h-3.7v-3.4h3.7V50.7z M69.5,44.7h-3.7v-3.4h3.7V44.7z M69.5,38.6h-3.7v-3.4h3.7V38.6z"
		/>
	</g>
)

/**
 * Email send icon
 * @returns Vector asset
 **/
export const EmailSendSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="71.6,37.6 29.3,63 66.3,100 100,100 100,66 " />
		<g class="node-icon">
			<g style="filter: brightness(.85)">
				<path d="M72,39.7v20.6c0,2.5-2,4.4-4.4,4.4H32.4c-2.5,0-4.4-2-4.4-4.4V39.7c0-0.5,0.3-1.6,0.3-1.6L71.7,38 C72,38.7,72,39.2,72,39.7z" />
				<path d="M33.8,42.6H22.1c-0.5,0-1-0.5-1-1v-0.2c0-0.5,0.5-1,1-1h11.6c0.5,0,1,0.5,1,1v0.2 C34.7,42.1,34.2,42.6,33.8,42.6z" />
				<path d="M32.2,47.7H20.5c-0.5,0-1-0.5-1-1v-0.2c0-0.5,0.5-1,1-1h11.6c0.5,0,1,0.5,1,1v0.2 C33.3,47.2,32.8,47.7,32.2,47.7z" />
				<ellipse cx="16.9" cy="46.6" rx="1.3" ry="1.1" />
				<path d="M35.5,52.8H23.9c-0.5,0-1-0.5-1-1v-0.2c0-0.5,0.5-1,1-1h11.6c0.5,0,1,0.5,1,1v0.2C36.5,52.5,36,52.8,35.5,52.8 z" />
			</g>

			<path d="M34.2,37.5H18.6c-0.5,0-1-0.5-1-1v-0.2c0-0.5,0.5-1,1-1h15.6c0.5,0,1,0.5,1,1v0.2 C35.2,37.1,34.7,37.5,34.2,37.5z" />
			<ellipse cx="14.8" cy="36.4" rx="1.3" ry="1.1" />
			<path d="M71.1,39.9L50.8,51.2c-0.2,0.2-0.5,0.2-0.8,0.2s-0.5,0-0.8-0.2L28.9,39.9c-0.6-0.3-0.9-1.2-0.6-1.9 c0.8-1.7,2.3-2.7,4.1-2.7h35.3c1.7,0,3.4,1.1,4.1,2.7C72,38.8,71.7,39.5,71.1,39.9z" />
		</g>
	</g>
)

/**
 * Email open icon
 * @returns Vector asset
 **/
export const EmailOpenSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon class="node-icon-shadow" points="71,39.2 28.7,64.5 65.7,100 100,100 100,67.6 	" />
		<g class="node-icon">
			<path
				style="filter: brightness(.85)"
				d="M72,41.6v20.6c0,2.5-2,4.4-4.4,4.4H32.4c-2.5,0-4.4-2-4.4-4.4V41.6c0-1.1,0.3-1.6,0.3-1.6l43.3-0.3 C71.7,39.7,72,40.2,72,41.6z"
			/>
			<path d="M71.7,40.1c-0.1-0.5-0.2-0.8-0.6-1.1c-0.8-0.5-20.3-11.4-20.3-11.4c-0.2-0.2-0.5-0.2-0.8-0.2 c-0.2,0-0.5,0-0.8,0.2c0,0-19.5,10.9-20.3,11.4c-0.5,0.3-0.6,0.6-0.6,0.9c-0.2,0.6,0,1.4,0.6,1.7l20.7,11.7c0.3,0.2,0.7,0.2,1,0 l20.4-11.7C71.5,41.5,71.8,40.7,71.7,40.1z" />
		</g>
		<path
			fill="#fff"
			d="M64.8,32.3c0-0.5-0.5-0.9-0.9-0.9H36.3c-0.5,0-0.9,0.5-0.9,0.9v13.1l14,7.8c0.2,0.2,0.5,0.2,0.8,0.2 s0.5,0,0.8-0.2l14-7.8V32.3H64.8z"
		/>
		<path class="node-icon-shadow" opacity=".5" d="M65,45.3l0.6-0.3l1.2-8.3c-0.6-0.3-1.2-0.8-1.9-1.1V45.3z" />
		<g fill="#999">
			<path
				class="st7"
				d="M57.7,38.7H42.3c-0.2,0-0.4-0.2-0.4-0.4v-0.7c0-0.2,0.2-0.4,0.4-0.4h15.4c0.2,0,0.4,0.2,0.4,0.4v0.7 C58.1,38.5,57.9,38.7,57.7,38.7z"
			/>
			<path
				class="st7"
				d="M57.7,42.4H42.3c-0.2,0-0.4-0.2-0.4-0.4v-0.7c0-0.2,0.2-0.4,0.4-0.4h15.4c0.2,0,0.4,0.2,0.4,0.4V42 C58.1,42.2,57.9,42.4,57.7,42.4z"
			/>
			<path
				class="st7"
				d="M53.9,46.1H42.3c-0.2,0-0.4-0.2-0.4-0.4V45c0-0.2,0.2-0.4,0.4-0.4h11.7c0.2,0,0.4,0.2,0.4,0.4v0.7 C54.3,46,54.2,46.1,53.9,46.1z"
			/>
		</g>
	</g>
)

/**
 * Email bounce icon
 * @returns Vector asset
 **/
export const EmailBounceSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon
			class="node-icon-shadow"
			points="46,57.6 43.2,55.9 37.5,60.2 32.8,69.8 26.7,63.8 19.5,61.5 15.2,62 24,70.7 23.5,71.4 53.1,100 92.2,100 100,100 100,46.5 77.5,24 		"
		/>

		<g class="node-icon">
			<path
				style="filter: brightness(.85)"
				d="M79.5,26.1l5.3,18.5c0.7,2.2-0.7,4.5-2.9,5.1l-31.9,9.1c-2.2,0.7-4.5-0.7-5.1-2.9l-5.4-19.7l39.3-11.4 C78.7,24.7,79.3,25.6,79.5,26.1z"
			/>

			<path d="M78.6,26.5L63.1,41.9c-0.2,0.2-0.4,0.2-0.7,0.4c-0.4,0-0.4,0.2-0.7,0l-21.2-5.1c-0.7-0.2-1.1-0.9-1.1-1.5 c0.2-1.8,1.5-3.1,2.9-3.4l31.9-9.1c1.6-0.4,3.4,0.2,4.4,1.3C79.1,25.2,79.1,25.9,78.6,26.5z" />
		</g>
		<g class="node-fill-icon-secondary">
			<ellipse style="filter: brightness(.95)" cx="32.1" cy="70.9" rx="8.9" ry="2" />

			<ellipse style="filter: brightness(.85)" cx="32.1" cy="70.7" rx="5.8" ry="1.3" />

			<path d="M30.3,65.1l-2,1.8c0.5,0.4,1.8,2.5,2.2,3.1l2.5-0.9C32.7,68.4,30.9,65.7,30.3,65.1z" />
			<path d="M23.2,60.9l-0.9,2.5c1.3,0.4,2.5,1.1,3.6,1.6l1.5-2.4C26.2,62,24.7,61.5,23.2,60.9z" />
			<path d="M15.3,59.3L15.1,62c1.5,0.2,2.7,0.4,4.2,0.5l0.5-2.7C18.4,59.7,16.9,59.5,15.3,59.3z" />
			<path d="M39,56.8l1.6,2.2c0.5-0.4,2.5-1.5,3.1-1.8l-1.1-2.5C41.9,54.8,39.8,55.9,39,56.8z" />
			<path d="M34.1,62.4l2.4,1.5c0.5-1.1,1.3-2,2.2-2.9l-2-1.8C35.6,60,34.7,61.1,34.1,62.4z" />
			<path d="M31.8,69.5l2.7,0.4c0.2-1.1,0.4-2.4,0.7-3.4l-2.5-0.9C32.1,66.7,32,68,31.8,69.5z" />
		</g>
	</g>
)

/**
 * Condition "if" icon
 * @returns Vector asset
 **/
export const ConditionIfSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<polygon
			class="node-icon-shadow"
			points="58.4,31.5 53.8,40.6 45,31.7 38.2,36.7 49.8,48.4 48,52.1 48,52.1 37.6,41.7 33.7,42.1 41.1,49.4 33.4,61.7 71.7,100 100,100 100,65 66.5,31.5 	"
		/>
		<g class="node-icon">
			<path d="M33.3,61.7l3-15.7l0.5-2.7c0-1.1-1.1-1.2-2.5-1.2h-0.7l0.5-1.8H43l-3,15.7l-0.2,2v0.5c0,0.9,0.9,1.2,2.5,1.2h0.5l-0.5,1.8 L33.3,61.7L33.3,61.7z M38.2,36.7l0.9-5h5.9l-0.9,5H38.2z" />
			<path d="M44.6,69.5l5.3-27.2h-3l0.5-2h2.8c0.9-3.2,2.5-5.7,4.5-7.3c1.8-1.8,4.1-2.5,6.8-2.5c1.1,0,1.8,0,2.7,0.2 c1.1,0.2,1.8,0.5,2.5,0.7l-0.9,5.9h-2.5v-0.5c0.2-1.4,0.2-2.5,0.2-2.7c0-0.7-0.2-0.9-0.7-1.2s-1.1-0.5-1.8-0.5 c-1.2,0-2.1,0.5-2.7,1.2c-0.7,1.1-1.1,2.7-1.8,5.2l-0.2,1.4h6.1l-0.2,2h-6.1l-5.7,27.2h-5.9C44.6,69.3,44.6,69.5,44.6,69.5z" />
		</g>
	</g>
)

/**
 * List icon
 * @returns Vector asset
 **/
export const ListSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<g class="node-icon">
			<circle cx="34.3" cy="36.2" r="3.8" />
			<path d="M68.5,40H45.9c-0.5,0-1-0.4-1-1v-4.1c0-0.5,0.4-1,1-1h22.7c0.5,0,1,0.4,1,1V39C69.5,39.6,69.1,40,68.5,40z" />
			<circle cx="34.3" cy="63.8" r="3.8" />
			<path d="M68.5,66.8H45.9c-0.5,0-1-0.4-1-1v-4.1c0-0.5,0.4-1,1-1h22.7c0.5,0,1,0.4,1,1v4.1C69.5,66.3,69.1,66.8,68.5,66.8z" />
			<circle cx="34.3" cy="50" r="3.8" />
			<path d="M68.5,53H45.9c-0.5,0-1-0.4-1-1V48c0-0.5,0.4-1,1-1h22.7c0.5,0,1,0.4,1,1V52C69.5,52.6,69.1,53,68.5,53z" />
		</g>
		<g class="node-icon-shadow" opacity=".3">
			<path d="M44.9,37v2c0,0.5,0.4,1,1,1h22.7c0.5,0,1-0.4,1-1v-2C61.3,37.2,53.1,37.2,44.9,37z" />
			<path d="M34.3,40c2.1,0,3.8-1.7,3.8-3.8c-2.5,0.3-5,0.3-7.5,0C30.5,38.3,32.2,40,34.3,40z" />
			<path d="M44.9,50v2c0,0.5,0.4,1,1,1h22.7c0.5,0,1-0.4,1-1v-2C61.3,50.3,53.1,50.3,44.9,50z" />
			<path d="M34.3,53.8c2.1,0,3.8-1.7,3.8-3.8c-2.5,0.3-5,0.3-7.5,0C30.5,52.1,32.2,53.8,34.3,53.8z" />
			<path d="M44.9,63.8v2c0,0.5,0.4,1,1,1h22.7c0.5,0,1-0.4,1-1v-2C61.3,64,53.1,64,44.9,63.8z" />
			<path d="M34.3,67.5c2.1,0,3.8-1.7,3.8-3.8c-2.5,0.3-5,0.3-7.5,0C30.5,65.8,32.2,67.5,34.3,67.5z" />
		</g>
	</g>
)

/**
 * Sms icon
 * @returns Vector asset
 **/
export const SmsSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path
			class="node-icon"
			d="M73.1,70.5l-10.3-6.6H32.7c-3.4,0-6.1-2.8-6.1-6.1V40.1c0-3.4,2.8-6.1,6.1-6.1H67c3.4,0,6.1,2.8,6.1,6.1 C73.1,40.1,73.1,70.5,73.1,70.5z"
		/>
		<g class="node-fill-inverted-primary">
			<path d="M42,45.3l-1.2,1.1C40.5,46.3,40.2,46,40,46c-0.2-0.2-0.5-0.2-0.8-0.2c-0.8,0-1.1,0.3-1.1,0.8 c0,0.3,0.5,0.8,1.4,1.1c0.9,0.3,1.5,0.8,2,1.2c0.5,0.5,0.6,0.9,0.6,1.5c0,0.8-0.3,1.4-0.9,1.8c-0.6,0.5-1.2,0.8-2,0.8 c-1.2,0-2.1-0.6-2.9-1.7l1.4-0.6c0.5,0.5,1.1,0.8,1.5,0.8c0.3,0,0.8-0.2,0.9-0.3c0.3-0.2,0.5-0.5,0.5-0.8c0-0.5-0.5-0.9-1.4-1.2 c-0.9-0.3-1.7-0.8-2-1.1c-0.3-0.5-0.6-0.9-0.6-1.4c0-0.8,0.3-1.2,0.8-1.7c0.5-0.5,1.2-0.8,2-0.8C40.2,44.1,41.1,44.6,42,45.3z" />
			<path d="M43.9,52.8v-8.4h1.7v1.2c0.5-0.5,0.8-0.9,1.2-1.2c0.3-0.3,0.8-0.3,1.4-0.3c0.6,0,1.1,0.2,1.5,0.5 c0.3,0.3,0.6,0.8,0.9,1.4c0.5-0.6,0.9-1.1,1.2-1.4c0.5-0.3,0.9-0.5,1.4-0.5c0.6,0,1.2,0.3,1.7,0.8c0.5,0.5,0.8,1.1,0.8,1.8v6.1 h-1.8v-5.7c0-0.9-0.5-1.4-1.4-1.4c-0.5,0-0.9,0.3-1.4,0.8c-0.3,0.5-0.6,1.1-0.6,1.8V53h-1.8v-5.5c0-1.1-0.2-1.7-1.1-1.7 c-0.6,0-1,0.1-1.3,0.6c-0.3,0.5-0.6,1.1-0.6,1.7v4.8H43.9z" />
			<path d="M63,45.3l-1.2,1.1C61.5,46.3,61.2,46,61,46c-0.2-0.2-0.5-0.2-0.8-0.2c-0.8,0-1.1,0.3-1.1,0.8 c0,0.3,0.5,0.8,1.4,1.1c0.9,0.3,1.5,0.8,2,1.2c0.5,0.5,0.6,0.9,0.6,1.5c0,0.8-0.3,1.4-0.9,1.8c-0.6,0.5-1.2,0.8-2,0.8 c-1.2,0-2.1-0.6-2.9-1.7l1.4-0.6c0.5,0.5,1.1,0.8,1.5,0.8c0.3,0,0.8-0.2,0.9-0.3c0.3-0.2,0.5-0.5,0.5-0.8c0-0.5-0.5-0.9-1.4-1.2 c-0.9-0.3-1.7-0.8-2-1.1c-0.3-0.5-0.6-0.9-0.6-1.4c0-0.8,0.3-1.2,0.8-1.7c0.5-0.5,1.2-0.8,2-0.8S62.1,44.6,63,45.3z" />
		</g>
	</g>
)

/**
 * Form icon
 * @returns Vector asset
 **/
export const FormSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path class="node-icon-shadow" d="M100,64L75.1,32.7L25,67.2L54.8,100H100V64z" />

		<rect class="node-icon" x="25.2" y="36.4" width="49.4" height="29" />
		<path
			class="node-fill-inverted-frame"
			d="M73.4,68H26.6c-1.2,0-2.2-1-2.2-2.2V34.2c0-1.2,1-2.2,2.2-2.2h46.9c1.2,0,2.2,1,2.2,2.2v31.6 C75.6,67,74.6,68,73.4,68z M26.6,37.3c-0.2,0-0.3,0.2-0.3,0.3v26.8c0,0.2,0.2,0.3,0.3,0.3h46.9c0.2,0,0.3-0.2,0.3-0.3V37.6 c0-0.2-0.2-0.3-0.3-0.3H26.6z"
		/>
		<g class="node-fill-inverted-primary" style="filter: saturate(4) hue-rotate(90deg) brightness(1.4)">
			<path d="M62.2,35.9H31.7c-0.3,0-0.7-0.3-0.7-0.7v-0.2c0-0.3,0.3-0.7,0.7-0.7h30.6c0.3,0,0.7,0.3,0.7,0.7v0.2 C62.9,35.6,62.6,35.9,62.2,35.9z" />
			<path d="M58.8,56.5H41.3c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5h17.5c0.3,0,0.5,0.2,0.5,0.5v1.4 C59.3,56.3,59,56.5,58.8,56.5z" />
			<path d="M48.8,45.8h-7.5c-0.3,0-0.5-0.3-0.5-0.5v-1.2c0-0.3,0.3-0.5,0.5-0.5h7.5c0.3,0,0.5,0.3,0.5,0.5v1.2 C49.3,45.4,49.2,45.8,48.8,45.8z" />
			<path d="M58.7,45.8h-7.5c-0.3,0-0.5-0.3-0.5-0.5v-1.2c0-0.3,0.3-0.5,0.5-0.5h7.5c0.3,0,0.5,0.3,0.5,0.5v1.2 C59.3,45.4,59,45.8,58.7,45.8z" />
			<path d="M58.7,52H41.2c-0.3,0-0.5-0.2-0.5-0.5v-1.4c0-0.3,0.2-0.5,0.5-0.5h17.5c0.3,0,0.5,0.2,0.5,0.5v1.4 C59.2,51.7,59,52,58.7,52z" />
		</g>
		<g class="node-fill-inverted-primary">
			<circle cx="29.3" cy="35.1" r="0.7" />
			<circle cx="27.4" cy="35.1" r="0.7" />
			<rect x="40.7" y="41.5" width="11.2" height="0.8" />
			<rect x="40.7" y="47.8" width="16.6" height="0.8" />
		</g>
		<g class="node-fill-icon-secondary">
			<path
				style="filter: saturate(4)"
				d="M53.2,60.4h-6.5c-0.3,0-0.5-0.2-0.5-0.5V59c0-0.3,0.2-0.5,0.5-0.5h6.5c0.3,0,0.5,0.2,0.5,0.5v0.8 C53.7,60,53.6,60.4,53.2,60.4z"
			/>
			<circle style="filter: saturate(4)" cx="73.6" cy="33.5" r="0.5" />
			<circle style="filter: saturate(4) hue-rotate(120deg)" cx="71.6" cy="33.5" r="0.5" />
			<circle style="filter: saturate(4) hue-rotate(240deg)" cx="69.7" cy="33.5" r="0.5" />
		</g>
	</g>
)

/**
 * Circular arrow
 * @returns Vector asset
 **/
export const CircularArrowSVG = () => (
	<g>
		<path
			class="primary"
			d="M97.3,45.6c-1.2-12.8-7.4-24.5-17.2-32.1c-8-6.7-18.3-10.3-29.2-10.3c-14.1,0-27.1,5.9-35.7,16.2l-0.1,0.1l-0.1,0.1c-0.1,0.1-0.2,0.2-0.3,0.3l-8.9-5.7c-1.4-0.9-3.3,0.1-3.3,1.7c0,0,0,0-0.1,0c0,0.2,0,0.4,0.1,0.6l0.6,28.7c0,1.5,1.5,2.5,2.9,2l28.7-10.3c1.7-0.6,2-2.9,0.4-3.9l-9.7-6.2l2-1.9c6.2-5.8,14.4-9,23.2-9c10,0,19.4,4.2,25.7,11.5c6.2,6.9,9.3,16.4,8.3,26c-1,9.7-5.9,18.4-13.4,23.9c-6,4.5-13,6.8-20.2,6.8c-5.9,0-11.9-1.6-17.6-4.6c-0.9-0.5-2-0.1-2.4,0.8c-0.2,0.3-0.3,0.6-0.4,0.8c0,0-2.7,4.9-3.2,5.9c-0.2,0.4-0.4,0.8-0.6,1.1c-0.5,0.9-0.1,2,0.7,2.5c3,1.6,6.2,3.1,9.5,4.1c4.3,1.4,8.8,2.1,13.5,2.1c14,0,27.4-6.2,36-16.7l0.1-0.1C94.6,70.9,98.5,58.3,97.3,45.6z"
		/>
	</g>
)

/**
 * Folder icon
 * @returns Vector asset
 **/
export const FolderSVG = ({ transform }: IconProps) => (
	<g transform={transform}>
		<path d="M84.8,29.4c-17.1,0-34.1,0-51.2,0c-6.3-0.3-11.7,4.3-13,10.4c-3.2,12.3-6.5,24.7-9.7,37c-0.8,3,1.5,5.2,4,5.1c2.2-0.1,3.9-1.6,4.5-3.7c3.3-12.2,6.4-24.5,9.7-36.7c0.7-2.8,2.6-4.6,5.4-5.4c18.8-0.4,37.8,0,56.6-0.1c3.7,0,6.6,2.9,6.4,6.5c-3.6,14.4-8.2,28.7-12.2,43c-1.7,6.2-9,4.9-14,5.8c-17.5,2-35.2,2-52.7,0.3c-3.4-0.3-6.7-0.8-10.1-1.1C6.2,90.1,4.4,89,3.2,87c-0.6-1-0.7-2.2-0.7-3.3c0-23.3,0-46.6,0-70c-0.1-3.5,2.8-6.4,6.4-6.4c6.3,0,12.5,0,18.8,0c2.3,0,4.2,1,5.5,2.9c1.3,2,2.7,4,4,6c0.3,0.5,0.6,0.6,1.1,0.6c13.4,0,26.8,0,40.2,0C85.8,17.2,84.9,23.9,84.8,29.4z" />
	</g>
)

/**
 * Clock icon
 * @returns Vector asset
 **/
export const SimpleClockSVG = ({ transform }: IconProps) => (
	<g>
		<path d="M50,2C23.4,2,2,23.4,2,50s21.4,48,48,48s48-21.4,48-48S76.6,2,50,2z M50,92.6C26.5,92.6,7.4,73.5,7.4,50 S26.5,7.4,50,7.4S92.6,26.5,92.6,50S73.5,92.6,50,92.6z" />
		<path d="M50,52H25.5c-1.3,0-2-1-2-2s1-2,2-2H50c1.3,0,2,1,2,2S51.3,52,50,52z" />
		<path d="M50,52c-0.5,0-1-0.3-1.5-0.8c-0.8-0.8-0.8-2.3,0-3.1l17.4-17.4c0.8-0.8,2.3-0.8,3.1,0c0.8,0.8,0.8,2.3,0,3.1 L51.5,51.3C51,52,50.5,52,50,52z" />
	</g>
)

/**
 * Tiny clock icon
 * @returns Vector asset
 **/
export const TinyClockSVG = () => (
	<svg viewBox="0 0 20 20">
		<g>
			<path
				fill="#fff"
				d="M10,4c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.3,4,10,4z M10,14.6c-2.6,0-4.6-2.1-4.6-4.6S7.5,5.4,10,5.4 s4.6,2.1,4.6,4.6S12.6,14.6,10,14.6z"
			/>
			<path
				fill="#fff"
				d="M10.4,7.4c-0.2,0-0.6,0.2-0.6,0.6v1.7H8c-0.2,0-0.6,0.2-0.6,0.6c0,0.2,0.2,0.6,0.6,0.6h2.3 c0.3,0,0.6-0.2,0.6-0.6V8C10.9,7.7,10.6,7.4,10.4,7.4z"
			/>
		</g>
	</svg>
)

/**
 * IF icon
 * @returns Vector asset
 **/
export const IfSVG = () => (
	<g>
		<path
			fill="#fff"
			d="M14,4.5c-0.8,0-1.6,0.5-1.9,0.8c-1.1,1-1.2,1.8-1.4,2.3H10c-0.1,0-0.1,0-0.1,0.1L9.8,8c0,0.1,0,0.1,0.1,0.1 h0.8l-1.2,4c-0.6,2-1.1,2.9-1.7,2.9c-0.2,0-0.3-0.1-0.3-0.2c0-0.5-0.3-0.7-0.7-0.7c-0.4,0-0.6,0.3-0.7,0.6c0,0.4,0.5,0.7,1.3,0.7 c1.6,0,2.6-1.1,3.5-3.2c0.5-1.2,0.9-3.3,1.2-4.2h1c0.1,0,0.1,0,0.1-0.1l0.1-0.3c0-0.1,0-0.1-0.1-0.1h-1C12.5,6.4,13,5,13.8,5 c0.3,0,0.4,0.2,0.5,0.3c0.1,0.3,0.1,0.6,0.6,0.6c0.4,0,0.7-0.3,0.7-0.6C15.6,4.9,15.1,4.5,14,4.5z M8.6,5.1c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.8-0.4,0.8-0.7C9.4,5.4,9.1,5.1,8.6,5.1z M8.1,7.4c-0.5,0-0.9,0.2-1.3,0.5c-0.6,0.4-1,0.9-1,0.9 c0,0,0,0.1,0,0.1l0.1,0.1c0,0,0.1,0,0.1,0c0.2-0.2,0.6-0.5,0.7-0.6c0.1-0.1,0.2,0,0.2,0c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.4 L6.4,9.9c-0.6,1.4-0.8,1.7-0.8,2.1c0,0.2,0.1,0.4,0.5,0.3c1.6-0.1,2.3-1.2,2.4-1.3c0-0.1,0-0.1,0-0.1l-0.2-0.2c0,0-0.1,0-0.1,0 c-0.1,0.1-0.7,0.7-0.9,0.7c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.3,0.2-0.5l0.8-1.7c0.3-0.7,0.4-1,0.4-1.2C8.6,7.6,8.5,7.4,8.1,7.4z"
		/>
	</g>
)

/**
 * condition box
 * @returns Vector asset
 **/
export const DynamicCondition = ({
	text,
	icon,
	accentColor = '#E82C58',
	rect_fill = '#231F20',
	x = 0,
	y = 0,
	height = 20,
	width = 100,
	rx = 5,
	badgeWidth = 20,
	text_fill = '#f3e8e8',
	fong_size = 8
}: any) => (
	<svg width={width} height={height}>
		<rect fill={rect_fill} width={width} height={height} x={x} y={y} rx={rx} />
		<path fill={accentColor} x={x} y={y} d={`M19.6,${badgeWidth}h-15c-2.8,0-5-2-5-4.5V4.5C-0.4,2,1.8,0,4.6,0h15V${badgeWidth}z`} />

		<path
			fill="#fff"
			d="M14,4.5c-0.8,0-1.6,0.5-1.9,0.8c-1.1,1-1.2,1.8-1.4,2.3H10c-0.1,0-0.1,0-0.1,0.1L9.8,8c0,0.1,0,0.1,0.1,0.1 h0.8l-1.2,4c-0.6,2-1.1,2.9-1.7,2.9c-0.2,0-0.3-0.1-0.3-0.2c0-0.5-0.3-0.7-0.7-0.7c-0.4,0-0.6,0.3-0.7,0.6c0,0.4,0.5,0.7,1.3,0.7 c1.6,0,2.6-1.1,3.5-3.2c0.5-1.2,0.9-3.3,1.2-4.2h1c0.1,0,0.1,0,0.1-0.1l0.1-0.3c0-0.1,0-0.1-0.1-0.1h-1C12.5,6.4,13,5,13.8,5 c0.3,0,0.4,0.2,0.5,0.3c0.1,0.3,0.1,0.6,0.6,0.6c0.4,0,0.7-0.3,0.7-0.6C15.6,4.9,15.1,4.5,14,4.5z M8.6,5.1c-0.4,0-0.7,0.3-0.7,0.7 c0,0.4,0.3,0.7,0.7,0.7c0.4,0,0.8-0.4,0.8-0.7C9.4,5.4,9.1,5.1,8.6,5.1z M8.1,7.4c-0.5,0-0.9,0.2-1.3,0.5c-0.6,0.4-1,0.9-1,0.9 c0,0,0,0.1,0,0.1l0.1,0.1c0,0,0.1,0,0.1,0c0.2-0.2,0.6-0.5,0.7-0.6c0.1-0.1,0.2,0,0.2,0c0,0,0,0.1,0,0.1c0,0.1-0.1,0.2-0.2,0.4 L6.4,9.9c-0.6,1.4-0.8,1.7-0.8,2.1c0,0.2,0.1,0.4,0.5,0.3c1.6-0.1,2.3-1.2,2.4-1.3c0-0.1,0-0.1,0-0.1l-0.2-0.2c0,0-0.1,0-0.1,0 c-0.1,0.1-0.7,0.7-0.9,0.7c-0.1,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.3,0.2-0.5l0.8-1.7c0.3-0.7,0.4-1,0.4-1.2C8.6,7.6,8.5,7.4,8.1,7.4z"
		/>

		<svg width={width - badgeWidth} height={height} x={badgeWidth}>
			<text text-anchor="middle" fill={text_fill} x={(width - badgeWidth) / 2} y="13" style={`font-size: ${fong_size}px;`} v-html={text}></text>
		</svg>
	</svg>
)

/**
 * condition box
 * @returns Vector asset
 **/
export const DynamicDelay = ({
	text,
	icon,
	accentColor = '#4958A7',
	rect_fill = '#231F20',
	x = 0,
	y = 0,
	height = 20,
	width = 100,
	rx = 5,
	badgeWidth = 20,
	text_fill = '#f3e8e8',
	fong_size = 8
}: any) => (
	<svg width={width} height={height}>
		<rect fill={rect_fill} width={width} height={height} x={x} y={y} rx={rx} />
		<path fill={accentColor} x={x} y={y} d={`M19.6,${badgeWidth}h-15c-2.8,0-5-2-5-4.5V4.5C-0.4,2,1.8,0,4.6,0h15V${badgeWidth}z`} />

		<path
			fill="#fff"
			d="M10,4c-3.3,0-6,2.7-6,6s2.7,6,6,6s6-2.7,6-6S13.3,4,10,4z M10,14.6c-2.6,0-4.6-2.1-4.6-4.6S7.5,5.4,10,5.4 s4.6,2.1,4.6,4.6S12.6,14.6,10,14.6z"
		/>
		<path
			fill="#fff"
			d="M10.4,7.4c-0.2,0-0.6,0.2-0.6,0.6v1.7H8c-0.2,0-0.6,0.2-0.6,0.6c0,0.2,0.2,0.6,0.6,0.6h2.3 c0.3,0,0.6-0.2,0.6-0.6V8C10.9,7.7,10.6,7.4,10.4,7.4z"
		/>

		<svg width={width - badgeWidth} height={height} x={badgeWidth}>
			<text text-anchor="middle" fill={text_fill} x={(width - badgeWidth) / 2} y="13" style={`font-size: ${fong_size}px;`} v-html={text}></text>
		</svg>
	</svg>
)

/**
 * delay tiny badge
 * @returns Vector asset
 **/
export const TinyDelayBadge = () => (
	<svg viewBox="0 0 100 100" width="18" height="18">
		<g class="frame">
			<circle fill="#C11E80" cx="50" cy="50" r="45" />
			<path
				fill="#651742"
				d="M58.3,98H40.8C19.1,98,1.5,80.4,1.5,58.8V41.3C1.5,19.7,19.1,2,40.8,2h17.5c21.7,0,39.3,17.6,39.3,39.3v17.5 C97.5,80.4,79.9,98,58.3,98z M40.8,10.8c-16.8,0-30.5,13.7-30.5,30.5v17.5c0,16.8,13.7,30.5,30.5,30.5h17.5 c16.8,0,30.5-13.7,30.5-30.5V41.3c0-16.8-13.7-30.5-30.5-30.5H40.8z"
			/>
		</g>
		<path
			class="icon"
			fill="#651742"
			d="M49.5,23.9c-14.4,0-26.2,11.8-26.2,26.2s11.8,26.2,26.2,26.2S75.7,64.4,75.7,50S63.9,23.9,49.5,23.9z M49.5,70.1c-11.3,0-20.1-9.2-20.1-20.1S38.6,30,49.5,30S69.6,39.1,69.6,50S60.9,70.1,49.5,70.1z"
		/>
		<path
			class="icon"
			fill="#651742"
			d="M51.3,38.7c-0.9,0-2.6,0.9-2.6,2.6v7.4h-7.9c-0.9,0-2.6,0.9-2.6,2.6c0,0.9,0.9,2.6,2.6,2.6h10 c1.3,0,2.6-0.9,2.6-2.6v-10C53.9,39.6,52.1,38.7,51.3,38.7z"
		/>
	</svg>
)

/**
 * condition tiny badge
 * @returns Vector asset
 **/
export const TinyConditionBadge = () => (
	<svg viewBox="0 0 100 100" width="18" height="18">
		<g class="frame">
			<circle fill="#C11E80" cx="50" cy="50" r="45" />
			<path
				fill="#651742"
				d="M58.3,98H40.8C19.1,98,1.5,80.4,1.5,58.8V41.3C1.5,19.7,19.1,2,40.8,2h17.5c21.7,0,39.3,17.6,39.3,39.3v17.5 C97.5,80.4,79.9,98,58.3,98z M40.8,10.8c-16.8,0-30.5,13.7-30.5,30.5v17.5c0,16.8,13.7,30.5,30.5,30.5h17.5 c16.8,0,30.5-13.7,30.5-30.5V41.3c0-16.8-13.7-30.5-30.5-30.5H40.8z"
			/>
		</g>
		<path
			class="icon"
			fill="#651742"
			d="M66.9,25c-3.8,0-7.6,2.4-9.1,3.8c-5.2,4.8-5.7,8.6-6.7,11h-3.3c-0.5,0-0.5,0-0.5,0.5l-0.5,1.4 c0,0.5,0,0.5,0.5,0.5h3.8l-5.7,19.1c-2.9,9.5-5.2,13.8-8.1,13.8c-1,0-1.4-0.5-1.4-1c0-2.4-1.4-3.3-3.3-3.3s-2.9,1.4-3.3,2.9  c0,1.9,2.4,3.3,6.2,3.3c7.6,0,12.4-5.2,16.7-15.3c2.4-5.7,4.3-15.7,5.7-20h4.8c0.5,0,0.5,0,0.5-0.5l0.5-1.4c0-0.5,0-0.5-0.5-0.5  h-4.8c1.4-5.2,3.8-11.9,7.6-11.9c1.4,0,1.9,1,2.4,1.4c0.5,1.4,0.5,2.9,2.9,2.9c1.9,0,3.3-1.4,3.3-2.9C74.6,26.9,72.2,25,66.9,25z M41.2,27.9c-1.9,0-3.3,1.4-3.3,3.3s1.4,3.3,3.3,3.3c1.9,0,3.8-1.9,3.8-3.3C45,29.3,43.6,27.9,41.2,27.9z M38.8,38.8  c-2.4,0-4.3,1-6.2,2.4c-2.9,1.9-4.8,4.3-4.8,4.3V46l0.5,0.5h0.5c1-1,2.9-2.4,3.3-2.9c0.5-0.5,1,0,1,0v0.5c0,0.5-0.5,1-1,1.9  l-1.4,4.8c-2.9,6.7-3.8,8.1-3.8,10c0,1,0.5,1.9,2.4,1.4c7.6-0.5,11-5.7,11.4-6.2c0-0.5,0-0.5,0-0.5l-1-1h-0.5  c-0.5,0.5-3.3,3.3-4.3,3.3c-0.5,0-0.5-0.5-0.5-1c0-0.5,0.5-1.4,1-2.4l3.8-8.1c1.4-3.3,1.9-4.8,1.9-5.7  C41.2,39.8,40.7,38.8,38.8,38.8z"
		/>
	</svg>
)

/**
 * page generic
 **/
export const PageGeneric = () => (
	<svg viewBox="0 0 100 130" class="page-node-svg">
		<path style="fill: var(--clr-white)" class="outline-stroke" d="M95,127H5c-1.1,0-2-0.9-2-2V15h94v110C97,126.1,96.1,127,95,127z" />
		<path style="fill: var(--clr-outline)" class="outline-stroke" d="M97,15H3V5c0-1.1,0.9-2,2-2h90c1.1,0,2,0.9,2,2V15z" />
		<path style="fill: var(--clr-white)" d="M60,12H14c-1.7,0-3-1.3-3-3v0c0-1.7,1.3-3,3-3h46c1.7,0,3,1.3,3,3v0C63,10.7,61.7,12,60,12z" />
		<path style="fill: var(--clr-warm-accent)" d="M93,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C94,10.6,93.6,11,93,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M86,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C87,10.6,86.6,11,86,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M79,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C80,10.6,79.6,11,79,11z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,59h76c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,59.4,11.4,59,12,59z" />
		<path style="fill: var(--clr-light-accent)" d="M23.5,66h53c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-53c-0.6,0-1-0.4-1-1v-1C22.5,66.4,22.9,66,23.5,66z" />
		<path style="fill: var(--clr-light-accent)" d="M18,73h64c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H18c-0.6,0-1-0.4-1-1v-1C17,73.4,17.4,73,18,73z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,86h34c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,86.4,11.4,86,12,86z" />
		<path style="fill: var(--clr-dark-accent)" d="M67,86h18c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H67c-0.6,0-1-0.4-1-1v-1C66,86.4,66.4,86,67,86z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,93h43c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,93.4,11.4,93,12,93z" />
		<path style="fill: var(--clr-dark-accent)" d="M67,93h12c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H67c-0.6,0-1-0.4-1-1v-1C66,93.4,66.4,93,67,93z" />
		<path style="fill: var(--clr-light-accent)" d="M12,100h38c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,100.4,11.4,100,12,100z" />
		<path style="fill: var(--clr-light-accent)" d="M12,107h45c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,107.4,11.4,107,12,107z" />
		<path style="fill: var(--clr-light-accent)" d="M67,107h10c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H67c-0.6,0-1-0.4-1-1v-1C66,107.4,66.4,107,67,107z" />
		<path style="fill: var(--clr-light-accent)" d="M67,100h16c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H67c-0.6,0-1-0.4-1-1v-1C66,100.4,66.4,100,67,100z" />
		<path style="fill: var(--clr-light-accent)" d="M12,114h31c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,114.4,11.4,114,12,114z" />
		<path style="fill: var(--clr-light-accent)" d="M67,114h13c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H67c-0.6,0-1-0.4-1-1v-1C66,114.4,66.4,114,67,114z" />
		<path class="blue-outline" d="M90,22H10c-0.6,0-1,0.4-1,1v30c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1V23C91,22.4,90.6,22,90,22z" />
		<path style="fill: var(--clr-blue)" d="M64,45.5H35l7.7-11l3.4,3.5l5.7-6.8l13.3,14.4H64z M37,44.5h25.9l-11-11.8l-5.6,6.8l-3.4-3.4L37,44.5z" />
		<path
			style="fill: var(--clr-blue)"
			d="M39.2,35.6c-1.3,0-2.4-1.1-2.4-2.6c0-1.4,1.1-2.6,2.4-2.6s2.4,1.1,2.4,2.6C41.6,34.5,40.5,35.6,39.2,35.6z M39.2,31.5c-0.8,0-1.4,0.7-1.4,1.6c0,0.9,0.6,1.6,1.4,1.6s1.4-0.7,1.4-1.6C40.6,32.2,40,31.5,39.2,31.5z"
		/>
	</svg>
)

/**
 * page import
 * @returns Vector asset
 **/
export const PageImport = () => (
	<svg viewBox="0 0 100 130" class="page-node-svg">
		<path style="fill: var(--clr-white)" class="outline-stroke" d="M95,127H5c-1.1,0-2-0.9-2-2V15h94v110C97,126.1,96.1,127,95,127z" />
		<path style="fill: var(--clr-outline)" class="outline-stroke" d="M97,15H3V5c0-1.1,0.9-2,2-2h90c1.1,0,2,0.9,2,2V15z" />
		<path style="fill: var(--clr-white)" d="M60,12H14c-1.7,0-3-1.3-3-3v0c0-1.7,1.3-3,3-3h46c1.7,0,3,1.3,3,3v0C63,10.7,61.7,12,60,12z" />
		<path style="fill: var(--clr-warm-accent)" d="M93,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C94,10.6,93.6,11,93,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M86,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C87,10.6,86.6,11,86,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M79,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C80,10.6,79.6,11,79,11z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,64h76c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,64.4,11.4,64,12,64z" />
		<path style="fill: var(--clr-light-accent)" d="M25.5,78h49c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-49c-0.6,0-1-0.4-1-1v-1C24.5,78.4,24.9,78,25.5,78z" />
		<path
			style="fill: var(--clr-blue); stroke: var(--clr-blue)"
			d="M90,105H10c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-8C91,105.4,90.6,105,90,105z"
		/>
		<path class="blue-outline" d="M90,91.5H10c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-7C91,91.9,90.6,91.5,90,91.5z" />
		<path style="fill: var(--clr-light-accent)" d="M16,71h68c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H16c-0.6,0-1-0.4-1-1v-1C15,71.4,15.4,71,16,71z" />
		<circle class="blue-outline" cx="50" cy="40" r="17.9" />
		<line style="stroke-width: 2" class="blue-outline" x1="50" y1="31" x2="50" y2="43.1" />
		<polyline style="stroke-width: 2" class="blue-outline" points="53.3,40.3 50,43.6 46.7,40.3 " />
		<path
			style="stroke-width: 2"
			class="blue-outline"
			d="M54.3,34.8c1.5,0,2.7,1.2,2.7,2.7v8.7c0,1.5-1.2,2.7-2.7,2.7h-8.7c-1.5,0-2.7-1.2-2.7-2.7v-8.7 c0-1.5,1.2-2.7,2.7-2.7"
		/>
		<path style="fill: var(--clr-white)" d="M37.7,113h-0.8v-5.7h0.8V113z" />
		<path style="fill: var(--clr-white)" d="M43.2,107.3h0.7v5.7h-0.8v-4.3l0,0.2l-1.4,3.2h-0.6l-1.4-3.1l0-0.3v4.3h-0.8v-5.7h0.7l1.7,3.8L43.2,107.3z" />
		<path
			style="fill: var(--clr-white)"
			d="M45.4,107.3h0.8v5.7h-0.8V107.3z M45.8,110h1.8c0.2,0,0.3,0,0.5-0.1s0.2-0.2,0.3-0.3s0.1-0.3,0.1-0.5 c0-0.2,0-0.4-0.1-0.5s-0.2-0.3-0.3-0.3s-0.3-0.1-0.5-0.1h-1.8v-0.8h1.8c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.6,0.6s0.2,0.6,0.2,0.9 s-0.1,0.7-0.2,0.9s-0.3,0.5-0.6,0.6s-0.6,0.2-0.9,0.2h-1.8V110z"
		/>
		<path
			style="fill: var(--clr-white)"
			d="M51.2,112.8c-0.3-0.2-0.5-0.4-0.7-0.7s-0.2-0.7-0.2-1.1v-1.6c0-0.4,0.1-0.8,0.2-1.1s0.4-0.6,0.7-0.7 c0.3-0.2,0.7-0.3,1-0.3c0.4,0,0.7,0.1,1,0.3c0.3,0.2,0.5,0.4,0.7,0.7c0.2,0.3,0.2,0.7,0.2,1.1v1.6c0,0.4-0.1,0.8-0.2,1.1 c-0.2,0.3-0.4,0.6-0.7,0.7c-0.3,0.2-0.7,0.3-1,0.3C51.8,113.1,51.5,113,51.2,112.8z M52.8,112.1c0.2-0.1,0.3-0.3,0.4-0.4 s0.1-0.4,0.1-0.7v-1.7c0-0.3,0-0.5-0.1-0.7s-0.2-0.3-0.4-0.4c-0.2-0.1-0.4-0.2-0.6-0.2s-0.4,0.1-0.6,0.2 c-0.2,0.1-0.3,0.3-0.4,0.4s-0.1,0.4-0.1,0.7v1.7c0,0.3,0,0.5,0.1,0.7s0.2,0.3,0.4,0.4c0.2,0.1,0.4,0.2,0.6,0.2 S52.7,112.2,52.8,112.1z"
		/>
		<path
			style="fill: var(--clr-white)"
			d="M55.5,107.3h0.8v5.7h-0.8V107.3z M55.8,109.8h1.9c0.2,0,0.3,0,0.4-0.1s0.2-0.2,0.3-0.3 c0.1-0.1,0.1-0.3,0.1-0.5s0-0.3-0.1-0.5c-0.1-0.1-0.2-0.2-0.3-0.3c-0.1-0.1-0.3-0.1-0.4-0.1h-1.9v-0.8h1.9c0.3,0,0.6,0.1,0.9,0.2 c0.2,0.1,0.4,0.3,0.6,0.6s0.2,0.5,0.2,0.9s-0.1,0.6-0.2,0.9c-0.1,0.2-0.3,0.4-0.6,0.6c-0.2,0.1-0.5,0.2-0.9,0.2h-1.9V109.8z  M57.4,110.4l0.8-0.2l1.5,2.8h-0.9L57.4,110.4z"
		/>
		<path style="fill: var(--clr-white)" d="M59.9,107.3h4v0.8h-4V107.3z M61.5,107.8h0.8v5.2h-0.8V107.8z" />
	</svg>
)

/**
 * Page opt in
 * @returns Vector asset
 **/
export const PageOptIn = () => (
	<svg viewBox="0 0 100 130" class="page-node-svg">
		<path style="fill: var(--clr-white)" class="outline-stroke" d="M95,127H5c-1.1,0-2-0.9-2-2V15h94v110C97,126.1,96.1,127,95,127z" />
		<path style="fill: var(--clr-outline)" class="outline-stroke" d="M97,15H3V5c0-1.1,0.9-2,2-2h90c1.1,0,2,0.9,2,2V15z" />
		<path style="fill: var(--clr-white)" d="M60,12H14c-1.7,0-3-1.3-3-3v0c0-1.7,1.3-3,3-3h46c1.7,0,3,1.3,3,3v0C63,10.7,61.7,12,60,12z" />
		<path style="fill: var(--clr-warm-accent)" d="M93,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C94,10.6,93.6,11,93,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M86,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C87,10.6,86.6,11,86,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M79,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C80,10.6,79.6,11,79,11z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,33h76c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,33.4,11.4,33,12,33z" />
		<path
			style="fill: var(--clr-blue); stroke: var(--clr-blue)"
			d="M90,98H10c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-8C91,98.4,90.6,98,90,98z"
		/>
		<path class="blue-outline" d="M90,80H10c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-7C91,80.4,90.6,80,90,80z" />
		<path
			style="fill: var(--clr-white)"
			d="M37.8,105.8c-0.3-0.2-0.5-0.4-0.7-0.7s-0.2-0.7-0.2-1.1v-1.6c0-0.4,0.1-0.8,0.2-1.1s0.4-0.6,0.7-0.7 s0.7-0.3,1-0.3s0.7,0.1,1,0.3s0.5,0.4,0.7,0.7s0.2,0.7,0.2,1.1v1.6c0,0.4-0.1,0.8-0.2,1.1s-0.4,0.6-0.7,0.7s-0.7,0.3-1,0.3 S38.1,106,37.8,105.8z M39.4,105.1c0.2-0.1,0.3-0.3,0.4-0.4s0.1-0.4,0.1-0.7v-1.7c0-0.3,0-0.5-0.1-0.7s-0.2-0.3-0.4-0.4 S39,101,38.8,101s-0.4,0.1-0.6,0.2s-0.3,0.3-0.4,0.4s-0.1,0.4-0.1,0.7v1.7c0,0.3,0,0.5,0.1,0.7s0.2,0.3,0.4,0.4s0.4,0.2,0.6,0.2 S39.2,105.2,39.4,105.1z"
		/>
		<path
			style="fill: var(--clr-white)"
			d="M42.1,100.3h0.8v5.7h-0.8V100.3z M42.5,103h1.8c0.2,0,0.3,0,0.5-0.1s0.2-0.2,0.3-0.3s0.1-0.3,0.1-0.5 c0-0.2,0-0.4-0.1-0.5s-0.2-0.3-0.3-0.3s-0.3-0.1-0.5-0.1h-1.8v-0.8h1.8c0.3,0,0.6,0.1,0.9,0.2s0.5,0.3,0.6,0.6s0.2,0.6,0.2,0.9 s-0.1,0.7-0.2,0.9s-0.3,0.5-0.6,0.6s-0.6,0.2-0.9,0.2h-1.8V103z"
		/>
		<path style="fill: var(--clr-white)" d="M46.3,100.3h4v0.8h-4V100.3z M47.9,100.8h0.8v5.2h-0.8V100.8z" />
		<path style="fill: var(--clr-white)" d="M53.9,106h-0.8v-5.7h0.8V106z" />
		<path style="fill: var(--clr-white)" d="M55.3,100.3H56l2.8,4.4l-0.1,0.1v-4.5h0.8v5.7h-0.7l-2.8-4.3l0.1-0.1v4.4h-0.8V100.3z" />
		<path class="blue-outline" d="M90,67H10c-0.6,0-1,0.4-1,1v7c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-7C91,67.4,90.6,67,90,67z" />
		<path
			style="fill: var(--clr-light-accent)"
			d="M20.5,53.5h60c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-60c-0.6,0-1-0.4-1-1v-1C19.5,53.9,19.9,53.5,20.5,53.5z"
		/>
		<path style="fill: var(--clr-light-accent)" d="M16,40h68c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H16c-0.6,0-1-0.4-1-1v-1C15,40.4,15.4,40,16,40z" />
		<path style="fill: var(--clr-light-accent)" d="M25.5,47h49c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1h-49c-0.6,0-1-0.4-1-1v-1C24.5,47.4,24.9,47,25.5,47z" />
	</svg>
)

/**
 * Page survey
 * @returns Vector asset
 **/
export const PageSurvey = () => (
	<svg viewBox="0 0 100 130" class="page-node-svg">
		<path style="fill: var(--clr-white)" class="outline-stroke" d="M95,127H5c-1.1,0-2-0.9-2-2V15h94v110C97,126.1,96.1,127,95,127z" />
		<path style="fill: var(--clr-outline)" class="outline-stroke" d="M97,15H3V5c0-1.1,0.9-2,2-2h90c1.1,0,2,0.9,2,2V15z" />
		<path
			style="fill: var(--clr-blue); stroke: var(--clr-blue)"
			d="M90,107H10c-0.6,0-1,0.4-1,1v8c0,0.6,0.4,1,1,1h80c0.6,0,1-0.4,1-1v-8C91,107.4,90.6,107,90,107z"
		/>
		<path
			style="fill: var(--clr-blue); stroke: var(--clr-blue)"
			d="M21,70h-4c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-4C22,70.4,21.6,70,21,70z"
		/>
		<path
			style="fill: var(--clr-blue); stroke: var(--clr-blue)"
			d="M21,92h-4c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-4C22,92.4,21.6,92,21,92z"
		/>
		<path style="fill: var(--clr-white)" d="M60,12H14c-1.7,0-3-1.3-3-3v0c0-1.7,1.3-3,3-3h46c1.7,0,3,1.3,3,3v0C63,10.7,61.7,12,60,12z" />
		<path style="fill: var(--clr-warm-accent)" d="M93,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C94,10.6,93.6,11,93,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M86,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C87,10.6,86.6,11,86,11z" />
		<path style="fill: var(--clr-warm-accent)" d="M79,11h-2c-0.6,0-1-0.4-1-1V8c0-0.6,0.4-1,1-1h2c0.6,0,1,0.4,1,1v2C80,10.6,79.6,11,79,11z" />
		<path style="fill: var(--clr-dark-accent)" d="M12,26h76c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H12c-0.6,0-1-0.4-1-1v-1C11,26.4,11.4,26,12,26z" />
		<path class="blue-outline" d="M86.5,56h-33c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h33c0.6,0,1-0.4,1-1v-6C87.5,56.4,87.1,56,86.5,56z" />
		<path class="blue-outline" d="M46.5,56h-33c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h33c0.6,0,1-0.4,1-1v-6C47.5,56.4,47.1,56,46.5,56z" />
		<path class="blue-outline" d="M86.5,42.7h-73c-0.6,0-1,0.4-1,1v6c0,0.6,0.4,1,1,1h73c0.6,0,1-0.4,1-1v-6C87.5,43.1,87.1,42.7,86.5,42.7z" />
		<path class="blue-outline" d="M21,81h-4c-0.6,0-1,0.4-1,1v4c0,0.6,0.4,1,1,1h4c0.6,0,1-0.4,1-1v-4C22,81.4,21.6,81,21,81z" />
		<path style="fill: var(--clr-light-accent)" d="M16,33h68c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H16c-0.6,0-1-0.4-1-1v-1C15,33.4,15.4,33,16,33z" />
		<path style="fill: var(--clr-light-accent)" d="M28,71.5h54c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H28c-0.6,0-1-0.4-1-1v-1C27,71.9,27.4,71.5,28,71.5z" />
		<path style="fill: var(--clr-light-accent)" d="M28,82.5h54c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H28c-0.6,0-1-0.4-1-1v-1C27,82.9,27.4,82.5,28,82.5z" />
		<path style="fill: var(--clr-light-accent)" d="M28,93.5h54c0.6,0,1,0.4,1,1v1c0,0.6-0.4,1-1,1H28c-0.6,0-1-0.4-1-1v-1C27,93.9,27.4,93.5,28,93.5z" />
		<path
			style="fill: var(--clr-white)"
			d="M37.7,115c-0.3-0.1-0.5-0.1-0.7-0.2s-0.4-0.2-0.6-0.4l0.5-0.9c0.2,0.2,0.5,0.3,0.8,0.4s0.6,0.1,0.9,0.1 c0.3,0,0.6-0.1,0.8-0.2s0.3-0.3,0.3-0.5v0c0-0.2,0-0.3-0.1-0.4s-0.2-0.2-0.3-0.2s-0.3-0.1-0.5-0.1c0,0,0,0,0,0s0,0,0,0l-0.1,0 c-0.4-0.1-0.7-0.1-0.9-0.2s-0.5-0.2-0.6-0.5s-0.3-0.5-0.3-1v0c0-0.4,0.1-0.7,0.2-0.9s0.4-0.5,0.7-0.6s0.7-0.2,1.1-0.2 c0.2,0,0.4,0,0.6,0.1s0.4,0.1,0.6,0.2s0.4,0.2,0.6,0.3l-0.5,0.9c-0.2-0.2-0.4-0.3-0.7-0.4s-0.5-0.1-0.7-0.1 c-0.3,0-0.6,0.1-0.8,0.2s-0.3,0.3-0.3,0.5v0c0,0.2,0,0.3,0.1,0.4s0.2,0.2,0.3,0.2s0.3,0.1,0.6,0.1c0,0,0,0,0,0s0,0,0,0 c0,0,0,0,0,0s0,0,0,0c0.4,0.1,0.7,0.2,0.9,0.3s0.4,0.3,0.6,0.5s0.2,0.5,0.2,0.9v0c0,0.4-0.1,0.7-0.3,0.9s-0.4,0.5-0.7,0.6 s-0.7,0.2-1.2,0.2C38.2,115.1,37.9,115,37.7,115z"
		/>
		<path
			style="fill: var(--clr-white)"
			d="M42.5,114.8c-0.3-0.2-0.5-0.4-0.7-0.7s-0.2-0.7-0.2-1.1v-3.6h1.1v3.7c0,0.3,0.1,0.6,0.3,0.8s0.4,0.3,0.7,0.3 c0.3,0,0.6-0.1,0.7-0.3s0.3-0.4,0.3-0.8v-3.7h1.1v3.6c0,0.4-0.1,0.8-0.2,1.1s-0.4,0.6-0.7,0.7s-0.7,0.2-1.1,0.2 S42.8,115,42.5,114.8z"
		/>
		<path
			style="fill: var(--clr-white)"
			d="M46.9,109.3h1.1v5.7h-1.1V109.3z M47.3,114h1.8c0.2,0,0.4-0.1,0.6-0.2s0.2-0.3,0.2-0.5v0 c0-0.1,0-0.3-0.1-0.4s-0.1-0.2-0.3-0.2s-0.3-0.1-0.4-0.1h-1.8v-1h1.8c0.2,0,0.4-0.1,0.5-0.2s0.2-0.3,0.2-0.5 c0-0.2-0.1-0.3-0.2-0.4s-0.3-0.2-0.5-0.2h-1.8v-1h1.8c0.4,0,0.7,0.1,0.9,0.2s0.5,0.3,0.6,0.5s0.2,0.5,0.2,0.8 c0,0.2,0,0.4-0.1,0.6s-0.2,0.3-0.4,0.4s-0.4,0.2-0.6,0.2c0.2,0,0.5,0.1,0.6,0.2s0.3,0.3,0.4,0.5s0.1,0.4,0.1,0.7v0 c0,0.3-0.1,0.6-0.2,0.8s-0.3,0.4-0.6,0.5s-0.6,0.2-0.9,0.2h-1.9V114z"
		/>
		<path style="fill: var(--clr-white)" d="M55.6,109.3H57v5.7h-1v-4.4l0,0.2l-1.1,3.5H54l-1.1-3.4l0-0.3v4.4h-1v-5.7h1.4l1.1,3.8L55.6,109.3z" />
		<path style="fill: var(--clr-white)" d="M59.3,115h-1.1v-5.7h1.1V115z" />
		<path style="fill: var(--clr-white)" d="M59.7,109.3h4.2v1h-4.2V109.3z M61.2,109.8h1.1v5.2h-1.1V109.8z" />
	</svg>
)

/**
 * EmailBounceFlat
 * @returns Vector asset
 **/ export const EmailBounceFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M69.2,29.3c-4.5,0-8.2,3.6-8.2,8.2s3.6,8.2,8.2,8.2c4.5,0,8.2-3.6,8.2-8.2S73.9,29.3,69.2,29.3z M74.5,37.8 c0,0.7-0.5,1.2-1.2,1.2h-7.9c-0.8,0-1.2-0.5-1.2-1.2v-0.6c0-0.8,0.5-1.2,1.2-1.2h7.9c0.8,0,1.2,0.5,1.2,1.2V37.8z" />
		<path d="M62.2,47.1c-3.2,2-6.4,4-9.6,6.1c-1.4,0.9-2.8,0.9-4.1,0c-2.9-1.9-5.8-3.6-8.6-5.5c-3.5-2.2-7.1-4.4-10.6-6.5 c-0.7-0.5-1.4-0.1-1.6,0.8c-0.1,0.2-0.1,0.6-0.1,1c0,6.6,0,13.2,0,19.9c0,3.5,1.8,5.4,5.4,5.4c5.9,0,11.7,0,17.6,0 c6,0,11.9,0,17.9,0c3.2,0,5.1-1.9,5.1-5.1c0-4.9,0-9.6,0-14.5c-1.4,0.5-2.9,0.9-4.2,0.9C66.6,49.4,64.1,48.7,62.2,47.1z" />
		<path d="M59,31.3c-2.8,0-5.5,0-8.4,0c-5.9,0-11.8,0-17.6,0c-1.1,0-2.2,0.3-3.1,0.7c-0.7,0.4-1.4,1.2-1.8,2.1 c-0.1,0.3,0.6,1.2,1.1,1.5c1.4,0.9,2.9,1.8,4.3,2.6c5.1,3.2,10.2,6.5,15.5,9.6c1.1,0.8,2.1,0.8,3.1,0c2.2-1.4,4.6-2.8,6.9-4.2 c-1.1-1.8-1.8-3.9-1.8-6.1C57.2,35.2,58,33.1,59,31.3z" />
	</g>
)

/**
 * EmailOpenFlat
 * @returns Vector asset
 **/ export const EmailOpenFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M50,68.1c-6.4,0-12.9,0-19.2,0c-3.6,0-5.6-2-5.6-5.6c0-7.7,0-15.5,0-23.1c0-2.6,1-4.6,3.4-5.9c6-3.4,12-7,18-10.5 c2.9-1.6,5.6-1.1,8.4,0.5c5.7,3.5,11.6,6.9,17.4,10.2c2,1.1,2.9,3,2.9,5.2c0,8,0,15.9,0,23.9c0,3.4-2.1,5.5-5.6,5.5 C62.8,68.1,56.5,68.1,50,68.1z M29.9,38.1c0.1,0.1,0.2,0.1,0.2,0.2c5.3,3.2,10.6,6.6,15.9,9.9c2.2,1.4,4.4,2.1,6.8,0.7 c4.2-2.5,8.4-5.1,12.6-7.8c1.6-1,3.2-2,5-3.1c-0.8-0.4-1.4-0.8-2-1.1c-5.4-3.1-10.8-6.4-16.1-9.5c-1.4-0.7-2.6-0.9-4-0.1 c-5.6,3.4-11.2,6.6-17,10C30.6,37.6,30.2,37.8,29.9,38.1z" />
		<path d="M52.5,38.1c0,1.6,0.1,3.2,0,4.9c-0.1,1.6-1.2,2.8-2.6,2.6c-1.2-0.1-2.2-1.4-2.2-2.9s0-3,0-4.5c-0.6,0-1.4,0-2-0.1 c-0.4-0.1-0.9-0.5-1-0.7c-0.1-0.4,0-1,0.4-1.4c1.4-1.5,2.8-2.9,4.1-4.2c0.6-0.6,1.4-0.8,2,0c1.4,1.4,2.8,2.8,4.1,4.2 c0.4,0.4,0.6,1.1,0.4,1.5c-0.2,0.4-0.9,0.6-1.5,0.8C53.6,38.2,53,38.1,52.5,38.1z" />
	</g>
)

/**
 * EmailNotOpenedFlat
 * @returns Vector asset
 **/ export const EmailNotOpenedFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M50,68.1c-6.4,0-12.9,0-19.2,0c-3.6,0-5.6-2-5.6-5.6c0-7.7,0-15.5,0-23.1c0-2.6,1-4.6,3.4-5.9c6-3.4,12-7,18-10.5 c2.9-1.6,5.6-1.1,8.4,0.5c5.7,3.5,11.6,6.9,17.4,10.2c2,1.1,2.9,3,2.9,5.2c0,8,0,15.9,0,23.9c0,3.4-2.1,5.5-5.6,5.5 C62.8,68.1,56.5,68.1,50,68.1z M29.9,38.1c0.1,0.1,0.2,0.1,0.2,0.2c5.3,3.2,10.6,6.6,15.9,9.9c2.2,1.4,4.4,2.1,6.8,0.7 c4.2-2.5,8.4-5.1,12.6-7.8c1.6-1,3.2-2,5-3.1c-0.8-0.4-1.4-0.8-2-1.1c-5.4-3.1-10.8-6.4-16.1-9.5c-1.4-0.7-2.6-0.9-4-0.1 c-5.6,3.4-11.2,6.6-17,10C30.6,37.6,30.2,37.8,29.9,38.1z" />
		<path d="M52.5,38.1c0,1.6,0.1,3.2,0,4.9c-0.1,1.6-1.2,2.8-2.6,2.6c-1.2-0.1-2.2-1.4-2.2-2.9s0-3,0-4.5c-0.6,0-1.4,0-2-0.1 c-0.4-0.1-0.9-0.5-1-0.7c-0.1-0.4,0-1,0.4-1.4c1.4-1.5,2.8-2.9,4.1-4.2c0.6-0.6,1.4-0.8,2,0c1.4,1.4,2.8,2.8,4.1,4.2 c0.4,0.4,0.6,1.1,0.4,1.5c-0.2,0.4-0.9,0.6-1.5,0.8C53.6,38.2,53,38.1,52.5,38.1z" />
		<path fill="#FF0000" d="M50,7.5C26.5,7.5,7.5,26.5,7.5,50s19,42.5,42.5,42.5s42.5-19,42.5-42.5S73.5,7.5,50,7.5z M50.5,14.2 c19.8,0,35.8,16,35.8,35.8c0,9-3.3,17.2-8.8,23.5L27.1,23C33.3,17.5,41.6,14.2,50.5,14.2z M14.7,50c0-8.7,3.1-16.6,8.2-22.8 l50.4,50.4c-6.2,5.1-14.1,8.2-22.8,8.2C30.8,85.8,14.7,69.7,14.7,50z"/>
	</g>
)

/**
 * UnsubFlat
 * @returns Vector asset
 **/ export const UnsubFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M57,68.1c-0.4,0.8-0.8,1.4-1.3,2.3c0,0-0.3,0-0.4,0c-5.6,0-11.3,0-16.9,0c-3,0-4.8-1.8-4.8-4.8c0-6.6,0-13.4,0-20 c0-0.1,0-0.1,0-0.3c0.3,0.1,0.4,0.1,0.5,0.3c4.4,2.8,8.8,5.5,13.3,8.3c1.5,0.9,2.9,1.8,4.4,2.8c1,0.6,2,0.6,3-0.1 c5.8-3.6,11.5-7.3,17.1-10.9c0.3-0.1,0.5-0.4,0.8-0.5c0,4.3,0,8.4,0,12.6c-1.8-0.6-3.5-0.4-5.1,0.4c-0.1,0-0.1,0-0.3,0.1 c-0.8,0.9-1.4,0.5-2.3,0c-2.6-1.6-6.3-1-8,1.3C55,62,54.9,65.6,57,68.1C57,68,57,68.1,57,68.1z" />
		<path d="M29.4,35.6c0,0.1,0,0.1,0,0.3c0,8.5,0,16.9,0,25.4c0,1-0.3,1.9-1.1,2.4c-0.8,0.4-1.6,0.5-2.1,0c-0.5-0.6-1-1.5-1-2.3 C25,52.7,25,44.2,25,35.9c0-2.9,1.9-4.6,5.1-4.6c10.5,0,20.9,0,31.4,0c1.4,0,2.4,0.6,2.6,1.9c0.1,1-0.3,1.8-1.1,2.1 c-0.5,0.3-1,0.4-1.5,0.4c-10.6,0-21.3,0-31.8,0C29.5,35.6,29.5,35.6,29.4,35.6z" />
		<path d="M34.6,41.2c1-0.4,1.8-0.9,2.6-1.1c0.5-0.1,1.1-0.1,1.8-0.3c9.8,0,19.4,0,29.1,0c1.3,0,2.5,0.3,3.4,1.4c0,0,0,0.1,0,0 c-3,1.9-5.9,3.8-8.9,5.6c-3.1,2-6.1,3.9-9.3,5.9c-0.1,0.1-0.4,0-0.5-0.1c-4.5-2.9-9-5.6-13.5-8.5c-1.5-0.9-2.9-1.8-4.4-2.6 C35,41.6,35,41.5,34.6,41.2z" />
		<path d="M70.4,69.3c1.3,1.3,2.6,2.5,3.9,3.9c0.9,0.9,0.9,2.1,0.1,2.9c-0.9,0.9-2.1,0.9-3,0c-1.3-1.3-2.5-2.5-3.8-3.8 c0,0-0.1-0.1-0.3-0.1c-0.9,0.9-1.8,1.8-2.5,2.6c-0.6,0.6-1.3,1.3-1.9,1.8c-0.6,0.5-1.9,0.3-2.5-0.4c-0.6-0.8-0.8-1.9-0.1-2.5 c1.3-1.4,2.6-2.6,3.9-4c0.1-0.1,0.1-0.3,0.1-0.1c-1.3-1.3-2.4-2.5-3.5-3.8c-0.9-0.9-1.3-1.9-0.8-2.8c0.5-1,1.3-1.6,2.3-1.3 c0.9,0.3,1.6,1.1,2.3,1.8c1,0.9,2,1.9,2.8,2.8c1.1-1.1,2.4-2.3,3.6-3.5c1.4-1.4,3-1.3,3.8,0.3c0.5,1,0.1,1.8-0.5,2.5 c-0.6,0.6-1.3,1.3-2,2C71.6,68,71,68.6,70.4,69.3z" />
	</g>
)

/**
 * ClickedFlat
 * @returns Vector asset
 **/ export const ClickedFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M44.1,57.5c0-5.1,0-10.1,0-15.2c0-1.4,0.6-2.2,1.6-2.2c0.6,0,1.4,0.4,1.7,0.7c4.1,3.6,8.2,7.2,12.3,10.9 c3.5,3.1,7,6.2,10.5,9.4c0.6,0.6,1.2,1.4,0.9,2.4s-1.2,1.1-2.1,1.2c-2.6,0.4-5.4,0.9-8.1,1.2c-1.4,0.2-2.6,0.2-4,0.6 c-0.7,0.2-1.4,0.9-2,1.5c-2.6,2.1-5.1,4.1-7.6,6.4c-0.6,0.5-1.4,0.9-2.1,0.5c-0.9-0.4-1.1-1.2-1.1-2.1 C44.1,67.6,44.1,62.6,44.1,57.5z" />

		<path d="M43.9,32.3c-0.6-2-1.1-4.1-1.7-6.1c-0.1-0.4-0.4-0.9-0.9-1c-0.4-0.2-1-0.2-1.5-0.1s-0.9,0.6-1.1,1c-0.1,0.4-0.1,0.9,0,1.4 c0.5,1.1,0.9,2.1,1.4,3.2l0.6,1.5c0.1,0.4,0.4,0.9,0.6,1.4c0.2,0.5,0.9,0.9,1.4,0.9c0.1,0,0.1,0,0.2,0c0.6-0.1,1-0.7,1-1.5v-0.1 C44,32.7,43.9,32.4,43.9,32.3z" />
		<path d="M54.9,26.6c-0.4-0.6-1-1-1.6-1c-0.7-0.1-1.4,0.4-1.6,1.1c-0.7,2-1.6,4-2.4,5.9c-0.1,0.1-0.1,0.4-0.1,0.6 c-0.1,0.6,0.1,1.1,0.6,1.4c0.1,0.1,0.4,0.1,0.6,0.1c0.4,0,0.6-0.1,0.9-0.4c0.2-0.1,0.4-0.5,0.6-0.7c0.4-0.6,0.6-1.2,1-1.9 c0.6-1.1,1.2-2.4,1.9-3.4C55.1,27.8,55.1,27.2,54.9,26.6z" />
		<path d="M37.3,36.9c-1.9-1-3.6-2-5.4-3c-0.5-0.2-1-0.4-1.5-0.1c-0.4,0.1-0.9,0.5-1.1,1c-0.2,0.5-0.2,1.1-0.1,1.5 c0.1,0.4,0.6,0.7,1.1,1c1.9,0.7,3.9,1.5,5.9,2.2c0.1,0.1,0.4,0.1,0.5,0.1h0.1l0,0c0.5,0,1.1-0.1,1.5-0.9c0.2-0.5,0.1-1-0.4-1.5 C37.7,37.2,37.5,37,37.3,36.9z" />
		<path d="M36.5,44.8c-0.1,0-0.4,0-0.5,0.1c-2.1,0.6-4.1,1.2-6.2,1.9c-0.7,0.2-1.1,0.9-1.1,1.6l0,0c0,0.7,0.4,1.4,0.9,1.7 c0.2,0.1,0.5,0.2,0.9,0.2c0.2,0,0.6-0.1,0.9-0.2c1-0.5,2.1-1,3.1-1.4c0.5-0.1,1-0.4,1.4-0.6l0.4-0.1c0.4-0.1,0.6-0.4,1-0.5 c0.6-0.4,0.9-1,0.7-1.6C37.8,45.1,37.2,44.6,36.5,44.8z" />
		<path d="M62.8,35.3c-0.5-0.4-1.1-0.4-1.9-0.1l-3.7,1.6c-0.6,0.4-1.4,0.6-2.1,0.9c-0.7,0.4-1.1,1.1-0.9,1.9 c0.1,0.6,0.7,0.9,1.4,0.9c0.1,0,0.4,0,0.5-0.1h0.1c0.1,0,0.1,0,0.1,0l6-1.7c0.9-0.2,1.2-0.7,1.2-1.6 C63.6,36.3,63.3,35.7,62.8,35.3z" />
	</g>
)

/**
 * BannedCursor
 * @returns Vector asset
 **/ export const BannedCursorSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M44.1,57.5c0-5.1,0-10.1,0-15.2c0-1.4,0.6-2.2,1.6-2.2c0.6,0,1.4,0.4,1.7,0.7c4.1,3.6,8.2,7.2,12.3,10.9 c3.5,3.1,7,6.2,10.5,9.4c0.6,0.6,1.2,1.4,0.9,2.4s-1.2,1.1-2.1,1.2c-2.6,0.4-5.4,0.9-8.1,1.2c-1.4,0.2-2.6,0.2-4,0.6 c-0.7,0.2-1.4,0.9-2,1.5c-2.6,2.1-5.1,4.1-7.6,6.4c-0.6,0.5-1.4,0.9-2.1,0.5c-0.9-0.4-1.1-1.2-1.1-2.1 C44.1,67.6,44.1,62.6,44.1,57.5z" />

<path d="M43.9,32.3c-0.6-2-1.1-4.1-1.7-6.1c-0.1-0.4-0.4-0.9-0.9-1c-0.4-0.2-1-0.2-1.5-0.1s-0.9,0.6-1.1,1c-0.1,0.4-0.1,0.9,0,1.4 c0.5,1.1,0.9,2.1,1.4,3.2l0.6,1.5c0.1,0.4,0.4,0.9,0.6,1.4c0.2,0.5,0.9,0.9,1.4,0.9c0.1,0,0.1,0,0.2,0c0.6-0.1,1-0.7,1-1.5v-0.1 C44,32.7,43.9,32.4,43.9,32.3z" />
<path d="M54.9,26.6c-0.4-0.6-1-1-1.6-1c-0.7-0.1-1.4,0.4-1.6,1.1c-0.7,2-1.6,4-2.4,5.9c-0.1,0.1-0.1,0.4-0.1,0.6 c-0.1,0.6,0.1,1.1,0.6,1.4c0.1,0.1,0.4,0.1,0.6,0.1c0.4,0,0.6-0.1,0.9-0.4c0.2-0.1,0.4-0.5,0.6-0.7c0.4-0.6,0.6-1.2,1-1.9 c0.6-1.1,1.2-2.4,1.9-3.4C55.1,27.8,55.1,27.2,54.9,26.6z" />
<path d="M37.3,36.9c-1.9-1-3.6-2-5.4-3c-0.5-0.2-1-0.4-1.5-0.1c-0.4,0.1-0.9,0.5-1.1,1c-0.2,0.5-0.2,1.1-0.1,1.5 c0.1,0.4,0.6,0.7,1.1,1c1.9,0.7,3.9,1.5,5.9,2.2c0.1,0.1,0.4,0.1,0.5,0.1h0.1l0,0c0.5,0,1.1-0.1,1.5-0.9c0.2-0.5,0.1-1-0.4-1.5 C37.7,37.2,37.5,37,37.3,36.9z" />
<path d="M36.5,44.8c-0.1,0-0.4,0-0.5,0.1c-2.1,0.6-4.1,1.2-6.2,1.9c-0.7,0.2-1.1,0.9-1.1,1.6l0,0c0,0.7,0.4,1.4,0.9,1.7 c0.2,0.1,0.5,0.2,0.9,0.2c0.2,0,0.6-0.1,0.9-0.2c1-0.5,2.1-1,3.1-1.4c0.5-0.1,1-0.4,1.4-0.6l0.4-0.1c0.4-0.1,0.6-0.4,1-0.5 c0.6-0.4,0.9-1,0.7-1.6C37.8,45.1,37.2,44.6,36.5,44.8z" />
<path d="M62.8,35.3c-0.5-0.4-1.1-0.4-1.9-0.1l-3.7,1.6c-0.6,0.4-1.4,0.6-2.1,0.9c-0.7,0.4-1.1,1.1-0.9,1.9 c0.1,0.6,0.7,0.9,1.4,0.9c0.1,0,0.4,0,0.5-0.1h0.1c0.1,0,0.1,0,0.1,0l6-1.7c0.9-0.2,1.2-0.7,1.2-1.6 C63.6,36.3,63.3,35.7,62.8,35.3z" />

<path fill="#FF0000" d="M50,7.5C26.5,7.5,7.5,26.5,7.5,50s19,42.5,42.5,42.5s42.5-19,42.5-42.5S73.5,7.5,50,7.5z M50.5,14.2 c19.8,0,35.8,16,35.8,35.8c0,9-3.3,17.2-8.8,23.5L27.1,23C33.3,17.5,41.6,14.2,50.5,14.2z M14.7,50c0-8.7,3.1-16.6,8.2-22.8 l50.4,50.4c-6.2,5.1-14.1,8.2-22.8,8.2C30.8,85.8,14.7,69.7,14.7,50z"/>
	</g>
)

/**
 * EmailFlat
 * @returns Vector asset
 **/ export const EmailFlatSVG = ({ transform }: IconProps) => (
	<g class="node-icon">
		<path d="M49.9,70c-6.4,0-12.8,0-19.1,0c-3.9,0-5.9-1.9-5.9-5.9c0-7.1,0-14.4,0-21.6c0-0.4,0-0.8,0.1-1.1c0.1-0.9,0.9-1.4,1.8-0.9 c3.9,2.4,7.6,4.6,11.5,7.1c3.1,1.9,6.4,3.9,9.4,5.9c1.5,1,2.9,1,4.4,0c6.9-4.4,13.8-8.6,20.6-12.9c0.4-0.3,1.1-0.5,1.4-0.4 c0.4,0.4,0.8,1,0.8,1.5c0.1,7.5,0.1,15.1,0,22.6c0,3.5-2.1,5.5-5.6,5.5C62.9,70,56.4,70,49.9,70z" />
		<path d="M50.2,30c6.4,0,12.9,0,19.1,0c1.6,0,3.4,0.4,4.4,1.8c0.8,0.9,0.6,2-0.4,2.6c-3.6,2.4-7.3,4.6-10.9,6.9 c-3.6,2.3-7.1,4.5-10.8,6.8c-1.1,0.8-2.4,0.8-3.4,0c-5.6-3.5-11.1-7-16.8-10.4c-1.5-0.9-3.1-1.9-4.6-2.9c-0.6-0.4-1.4-1.4-1.3-1.6 c0.4-0.9,1-1.9,1.9-2.4c1-0.6,2.3-0.8,3.4-0.8C37.3,30,43.8,30,50.2,30z" />
	</g>
)

/**
 * AnsweredSurvey
 * @returns Vector asset
 **/
export const AnsweredSurveySVG = ({ transform }: IconProps) => (

<g class="node-icon">
<path d="M72.2,45.1c-1.6,0-2.8,1.3-2.8,2.8v2c0,10.7-8.7,19.3-19.4,19.3c0,0,0,0,0,0c-5.2,0-10-2-13.7-5.7 c-3.7-3.7-5.7-8.5-5.7-13.7c0-5.2,2-10,5.7-13.7c3.7-3.7,8.5-5.7,13.7-5.7c0,0,0,0,0,0c2.7,0,5.4,0.6,7.9,1.7 c1.4,0.6,3.1,0,3.7-1.4c0.6-1.4,0-3.1-1.4-3.7C57,25.7,53.5,25,50,25c0,0,0,0,0,0c-6.7,0-12.9,2.6-17.7,7.3C27.6,37,25,43.3,25,50 c0,6.7,2.6,13,7.3,17.7C37,72.4,43.3,75,50,75c0,0,0,0,0,0c13.8,0,25-11.2,25-25v-2C75,46.4,73.7,45.1,72.2,45.1z"/>
	<path d="M45.3,45.8c-1.1-1.1-2.9-1.1-4,0c-1.1,1.1-1.1,2.9,0,4l6.7,6.7c0.5,0.5,1.2,0.8,2,0.8c0,0,0,0,0,0c0.7,0,1.5-0.3,2-0.8 l22.2-22.2c1.1-1.1,1.1-2.9,0-4c-1.1-1.1-2.9-1.1-4,0L50,50.5L45.3,45.8z"/>
</g>
	)
/**
 * NotAnsweredSurvey
 * @returns Vector asset
 **/
export const NotAnsweredSurveySVG = ({ transform }: IconProps) => (

<g class="node-icon">
<path d="M72.2,45.1c-1.6,0-2.8,1.3-2.8,2.8v2c0,10.7-8.7,19.3-19.4,19.3c0,0,0,0,0,0c-5.2,0-10-2-13.7-5.7 c-3.7-3.7-5.7-8.5-5.7-13.7c0-5.2,2-10,5.7-13.7c3.7-3.7,8.5-5.7,13.7-5.7c0,0,0,0,0,0c2.7,0,5.4,0.6,7.9,1.7 c1.4,0.6,3.1,0,3.7-1.4c0.6-1.4,0-3.1-1.4-3.7C57,25.7,53.5,25,50,25c0,0,0,0,0,0c-6.7,0-12.9,2.6-17.7,7.3C27.6,37,25,43.3,25,50 c0,6.7,2.6,13,7.3,17.7C37,72.4,43.3,75,50,75c0,0,0,0,0,0c13.8,0,25-11.2,25-25v-2C75,46.4,73.7,45.1,72.2,45.1z"/>
	<path d="M45.3,45.8c-1.1-1.1-2.9-1.1-4,0c-1.1,1.1-1.1,2.9,0,4l6.7,6.7c0.5,0.5,1.2,0.8,2,0.8c0,0,0,0,0,0c0.7,0,1.5-0.3,2-0.8 l22.2-22.2c1.1-1.1,1.1-2.9,0-4c-1.1-1.1-2.9-1.1-4,0L50,50.5L45.3,45.8z"/>
		<path fill="#FF0000" d="M50,7.5C26.5,7.5,7.5,26.5,7.5,50s19,42.5,42.5,42.5s42.5-19,42.5-42.5S73.5,7.5,50,7.5z M50.5,14.2 c19.8,0,35.8,16,35.8,35.8c0,9-3.3,17.2-8.8,23.5L27.1,23C33.3,17.5,41.6,14.2,50.5,14.2z M14.7,50c0-8.7,3.1-16.6,8.2-22.8 l50.4,50.4c-6.2,5.1-14.1,8.2-22.8,8.2C30.8,85.8,14.7,69.7,14.7,50z"/>
</g>
	)
////*** TEMPLATE */

// /**
//  * Name
//  * @returns Vector asset
//  **/
// export const SVG = ({ transform }: IconProps) =>
// <g>

// </g>
